const plansData = [
    {
        "identity": "pl-0010",
        "name": "Casa cabaña",
        "category": "Casa",
        "area": 200,
        "rooms": 4,
        "floors": 2,
        "front": 10,
        "depth": 20,
        "dimencion": "10x20",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 25,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Sanitarias",
            "Inst. Eléctricas"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906484/wb0gbqewtc9v2uoz7to8.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906517/eltghjaex78qjgymdfy5.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906530/t9ipg7xn3dguvpilqmpw.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906543/vpy8qrxixtqheexnq2oq.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Capacidad y Privacidad",
        "description": "Diseño unifamiliar optimizado con distribución inteligente: zona social integrada en planta baja y área privada de tres dormitorios en el segundo nivel. Incluye un dormitorio adicional versátil y azotea aprovechable, ideal para entornos urbanos que buscan confort y privacidad.",
        "masVendidos": false,
        "level": 1,
        "style": "Rústico",
        "cantidLaminas": 6,
        "id": 1
    },
    {
        "identity": "pl-0011",
        "name": "Casa de Clasica",
        "category": "Casa",
        "area": 240,
        "rooms": 4,
        "floors": 3,
        "front": 12,
        "depth": 20,
        "dimencion": "12x21",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 25,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Estructuras",
            "Arquitectura",
            "Inst. Eléctricas",
            "Inst. Sanitarias"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777908328/lv7xdsxnbcmvibpzwlie.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777908352/dlxxa0djxxpmm2oraqnr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777908366/gdknpwdxtgxbzcbspr2j.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777908390/wdhsnh3vqzruichvs9qz.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777908544/ocgg2lt82bd6hjuwkucf.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777908570/fb11j6by6i4w9xfskeds.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Diseño Unifamiliar",
        "description": "Diseño unifamiliar de dos niveles con una propuesta volumétrica moderna y funcional. La planta baja destaca por un amplio estacionamiento techado para dos vehículos y una distribución abierta que conecta la sala, el comedor y una cocina con acceso directo al patio posterior. El segundo nivel alberga la zona privada con dormitorios bien iluminados y ventilados, mientras que la fachada principal incorpora elementos arquitectónicos contemporáneos, como arcos decorativos y una terraza frontal que jerarquiza el ingreso.",
        "masVendidos": false,
        "level": 1,
        "style": "Clásico",
        "cantidLaminas": 5,
        "id": 2
    },
    {
        "identity": "pl-0012",
        "name": "Edificación de uso mixto",
        "category": "Comercial",
        "area": 240,
        "rooms": 12,
        "floors": 5,
        "front": 12,
        "depth": 20,
        "dimencion": "12x20",
        "price": 100,
        "type": "plano",
        "packageType": "Completo",
        "originalPrice": 150,
        "badge": "TOP",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777909223/epqz3ciuwbumlxfwzwer.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777909232/vvnz5u9jucbewu8jxyhr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777909242/debfgsqt07j2m2auubeb.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777909256/cvwqwna6hyyxxjhzstf5.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777909271/ypydtdkdpsxlklkjoadr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777909294/kytpxqtavofotdygbf5v.jpg"
        ],
        "planType": "Premium",
        "bonus": "",
        "idealFor": "Vivienda y Negocio",
        "description": "Diseño integral de edificio multifuncional que consta de cinco niveles y una azotea equipada. El primer nivel está optimizado para la logística y el comercio, contando con cuatro amplias cocheras y locales comerciales independientes. Del segundo al quinto nivel, el modelo propone una distribución repetitiva que combina locales comerciales frontales con departamentos residenciales posteriores, cada uno con tres dormitorios, sala-comedor, cocina y lavandería. La azotea remata el proyecto con una zona social que incluye terraza BBQ y depósitos, ofreciendo una solución completa para inversión inmobiliaria.",
        "masVendidos": true,
        "level": 4,
        "style": "Moderno",
        "cantidLaminas": 31,
        "id": 3
    },
    {
        "identity": "pl-0013",
        "name": "Comercial y residencial",
        "category": "Comercial",
        "area": 168,
        "rooms": 14,
        "floors": 3,
        "front": 7,
        "depth": 24,
        "dimencion": "7x24",
        "price": 50,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 60,
        "badge": "OFer",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777909821/iw2uppwgxx2zdsmrz17x.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777909850/vpi0hvsezicbncwilmkz.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777909861/nblofyhffrgiugwqvpjr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777909875/oetngxeuwybqoqeup54y.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777909896/vweifconnizoaum3xzic.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Emprendimiento en casa",
        "description": "Este modelo arquitectónico de tres niveles está diseñado para maximizar el rendimiento de terrenos estrechos y profundos. La primera planta ofrece una planta libre destinada íntegramente a área comercial, optimizando la visibilidad y el flujo de clientes. El segundo y tercer nivel proponen una distribución inteligente de múltiples unidades de dormitorio, cada una con su propio servicio higiénico privado, conectadas por un pasillo central iluminado. Es una solución técnica ideal para proyectos de inversión destinados al alquiler de habitaciones o estudios, integrando funcionalidad comercial y residencial en un solo diseño",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 9,
        "id": 4
    },
    {
        "identity": "pl-0014",
        "name": "Vivienda Comercial",
        "category": "Casa",
        "area": 270,
        "rooms": 3,
        "floors": 4,
        "front": 9,
        "depth": 30,
        "dimencion": "9x30",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777910276/gxtgxjumetofaxlowsto.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777910299/ibdblywxkkjnetdrpc3o.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777910312/t2ytb5fekbk5c85ay7on.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777910334/afyccg0swdc3idm3wiev.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Oportunidad de Inversión Múltiple",
        "description": "Diseño arquitectónico integral para un centro comercial y de servicios con tres niveles operativos. El proyecto cuenta con un sótano destinado a estacionamiento privado con rampa de acceso y capacidad para varios vehículos. En la planta baja, el diseño prioriza la actividad comercial con una galería de seis tiendas independientes conectadas por un pasillo público, además de servicios higiénicos múltiples y depósitos. El primer piso está configurado específicamente para un área de restaurante con cocina industrial, zona de mesas, vestidores y un patio posterior, ofreciendo una solución completa para emprendimientos gastronómicos y de retail en un solo modelo.",
        "masVendidos": false,
        "level": 2,
        "style": "Moderno",
        "cantidLaminas": 3,
        "id": 5
    },
    {
        "identity": "pl-0015",
        "name": "Vivienda Multifamiliar Dúplex",
        "category": "Casa",
        "area": 220,
        "rooms": 12,
        "floors": 6,
        "front": 10,
        "depth": 22,
        "dimencion": "10x22",
        "price": 50,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 60,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777910655/ti8c9n4bnana1bqxvag8.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777910668/iy9y1o9bius79d2j5595.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777910675/h1as8buyiyrma9zm7lrv.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777910685/qgnty1r5ralb0dz8dowt.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777910694/t40lcsrj3wpad9uh5elm.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777910708/t61f6e1lzxu2lgwhvvo9.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "vivienda multifamiliar Duplex",
        "description": "Diseño de vivienda multifamiliar tipo dúplex con una distribución espejada y funcional en varios niveles. La planta de ingreso destaca por una zona social integrada que incluye sala, comedor y un moderno kitchenette, además de un estudio privado ideal para el trabajo remoto. La zona íntima está conectada por elegantes escaleras circulares que conducen a dormitorios secundarios con clósets empotrados y una sala de TV común, culminando en un amplio dormitorio principal que garantiza privacidad y confort. El diseño se complementa con áreas de servicio como lavandería y patios internos que aseguran una óptima ventilación e iluminación natural en todo el edificio.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 10,
        "id": 6
    },
    {
        "identity": "pl-0016",
        "name": "Vivienda unifamiliar con comercio",
        "category": "Casa",
        "area": 120,
        "rooms": 3,
        "floors": 3,
        "front": 6,
        "depth": 20,
        "dimencion": "6x20",
        "price": 40,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 60,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777911229/t2ubeg68cwpkfboihzng.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777911244/vsx99hvndvu30b8ce3et.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777911255/lakhaxhmxy2ay8cj5nld.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777911268/uoqpiwaaf82ymgk3w6qg.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777911281/ag64f4syvjogeuahivcu.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": [],
        "description": "Diseño arquitectónico versátil de tres niveles que integra armónicamente el uso comercial y residencial. La primera planta propone un área de comercio de planta libre con acceso independiente, depósito y servicios, ideal para negocios de atención al público. El segundo y tercer nivel albergan una vivienda completa con una distribución inteligente que incluye sala-comedor, cocina, lavandería y múltiples dormitorios con clósets empotrados. El proyecto culmina en una azotea técnica transitable, ofreciendo un modelo de edificación funcional que permite generar ingresos sin sacrificar la privacidad del hogar.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 6,
        "id": 7
    },
    {
        "identity": "pl-0017",
        "name": "Vivienda unifamiliar",
        "category": "Casa",
        "area": 120,
        "rooms": 3,
        "floors": 4,
        "front": 6,
        "depth": 19,
        "dimencion": "6x20",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777912234/w2c3hzj3sf2llw5zhwzm.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777912241/o4j6mhbwvwu3svvqjrg9.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777912255/iuwnyelr7ucldarufmjn.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777912266/g47mn2cwrbqfmiaoeatu.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777912288/lancscaxbnhleued8xby.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Diseño Unifamiliar Con aéreas Verdes",
        "description": "Diseño residencial contemporáneo distribuido en dos niveles que prioriza la iluminación natural y la funcionalidad de los espacios. La planta baja cuenta con un ingreso que integra garaje y jardín frontal, seguido por un estudio privado y una zona social abierta con sala, comedor y cocina con vista a un patio interno. El primer nivel también incluye dos dormitorios, uno de ellos con un generoso walking closet. El segundo nivel amplía la zona íntima con dormitorios adicionales, mientras que la azotea ofrece una amplia planta libre para usos múltiples, garantizando una vivienda espaciosa y bien ventilada mediante retiros y patios estratégicos.",
        "masVendidos": true,
        "level": 3,
        "style": "",
        "cantidLaminas": 6,
        "id": 8
    },
    {
        "identity": "pl-0018",
        "name": "Vivienda unifamiliar 2 Niveles",
        "category": "Casa",
        "area": 270,
        "rooms": 4,
        "floors": 3,
        "front": 9,
        "depth": 22,
        "dimencion": "9x22",
        "price": 100,
        "type": "plano",
        "packageType": "Completo",
        "originalPrice": 120,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Cortes y Secciones",
            "Inst. Sanitarias",
            "Inst. Eléctricas",
            "Estructuras",
            "Arquitectura"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777912880/fzblcqnn8g6jgwfvz1fg.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777912894/mneza9e6g4gzvpmwjgbl.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777912904/kvbq7luzpbri9mzntq5l.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777912915/raime5kougff9igivvxf.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777912932/dmh5agclfbjqgzrzufyg.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777912952/dn9fhcqaiwrvaakhrj2m.jpg"
        ],
        "planType": "Premium",
        "bonus": "",
        "idealFor": "Familias que buscan un equilibrio entre áreas compartidas",
        "description": "Diseño residencial de 3 niveles que destaca por su distribución fluida y excelente iluminación natural. La primera planta ofrece una zona social integrada con sala y comedor, una cocina funcional con acceso a un patio de servicio, y un dormitorio principal con baño privado y clóset. El segundo nivel amplía la capacidad de la vivienda con tres dormitorios adicionales, múltiples servicios higiénicos y una amplia terraza techada ideal para el esparcimiento. El proyecto se complementa con un jardín exterior, estacionamiento privado y un jardín interior que asegura frescura en todos los ambientes.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 36,
        "id": 9
    },
    {
        "identity": "pl-0019",
        "name": "Modelo vivienda unifamiliar  prioriza amplitud y iluminación",
        "category": "Casa",
        "area": 162,
        "rooms": 4,
        "floors": 3,
        "front": 9,
        "depth": 18,
        "dimencion": "9x18",
        "price": 60,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 80,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777913244/szvamzpx8ajjsvla7uwl.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777913258/kqwxkmt8tmt1tn6tsf69.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777913268/cfhtcolhxgrefhqdic8t.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777913279/wijxo6yiqc1nl6lqlndt.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777913290/ie6xvnetzglplcwutchh.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777913312/ajuu6lfpnzr1ile9saqb.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Para Familias que deseen Espacios de Trabajo y Estudio",
        "description": "Modelo de vivienda unifamiliar que prioriza la amplitud y la iluminación cenital a través de un importante vacío central sobre la zona de escaleras. La planta baja ofrece una experiencia de concepto abierto, integrando sala y comedor con una transición fluida hacia una terraza posterior y un jardín frontal con garaje. El programa se completa con un estudio independiente y una cocina lineal de diseño eficiente. En el segundo nivel, la zona privada se organiza alrededor de un estar familiar, contando con tres dormitorios, destacando la habitación principal con 'wall closet' y terraza privada.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 12,
        "id": 10
    },
    {
        "identity": "pl-0020",
        "name": "Vivienda unifamiliar",
        "category": "Casa",
        "area": 170,
        "rooms": 3,
        "floors": 2,
        "front": 10,
        "depth": 17,
        "dimencion": "10x17",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777914322/wbzmxebep5mq0cog3fy0.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777914329/c5lklsrnbpwkj6uafvpf.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777914337/bazcagpsfjge4kdz0yny.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777914351/p14u8oqj1uarezlvlj6c.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Diseño ideal para familias que ofrecen amplio garaje",
        "description": "Propuesta arquitectónica de dos plantas que destaca por una zona social de doble ambiente y un amplio garaje para dos vehículos. El primer nivel integra una sala de recepción, comedor independiente y cocina con barra, además de un dormitorio secundario ideal para visitas o personas mayores. La segunda planta está dedicada al confort privado, albergando una generosa sala de estar íntima y el dormitorio principal, el cual cuenta con un exclusivo walk-in closet y baño privado de gran tamaño.",
        "masVendidos": false,
        "level": 2,
        "style": "Moderno",
        "cantidLaminas": 6,
        "id": 11
    },
    {
        "identity": "pl-0021",
        "name": "Edificación Multifamiliar",
        "category": "Departamento",
        "area": 234,
        "rooms": 4,
        "floors": 5,
        "front": 13,
        "depth": 18,
        "dimencion": "13x18",
        "price": 20,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777914729/s7gy1jjon9mvelemwylg.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777914741/kkjnhq6meggspfhk8ncr.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777914748/lsepfqglvbrxpqpvss83.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777914756/irwzgn6v7mtn8nzcjsdv.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777914775/po26xvlxg5e15xwyqtz1.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Inversión, Patrimonio y Independencia por Nivel",
        "description": "Proyecto de edificación de cuatro niveles con una distribución inteligente que combina un primer piso de planta libre, ideal para estacionamientos o áreas comunes, con niveles superiores destinados a vivienda. Cada una de las plantas típicas (del segundo al cuarto nivel) está diseñada para albergar dos departamentos independientes por piso, cada uno con sala-comedor, cocina funcional y dormitorios con iluminación natural. El diseño destaca por su núcleo de escaleras central y pozos de luz estratégicos que garantizan ventilación y confort en todas las unidades.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 5,
        "id": 12
    },
    {
        "identity": "pl-0022",
        "name": "Comercial y residencial",
        "category": "Comercial",
        "area": 128,
        "rooms": 6,
        "floors": 3,
        "front": 8,
        "depth": 16,
        "dimencion": "8x16",
        "price": 45,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 60,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915099/ifzyumw8lazwnmukirbr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915115/kan2opiuzrwcwddxpbhb.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915126/udueq7iyfzy96nql8scz.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915133/uaiu5fgecyob5c6sqzou.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915156/rszzxd0nfv5hwtw1weln.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Emprendimiento en Casa y Distribución Privada",
        "description": "Propuesta arquitectónica de dos niveles diseñada para lotes con frente a calle, optimizando la distribución entre un primer piso funcional y un segundo nivel residencial completo. La planta baja destaca por un amplio salón multiuso con acceso mediante puerta levadiza y un área de almacén, ideal para actividades comerciales o talleres privados. El segundo piso alberga una vivienda independiente con sala-comedor, cocina, tres dormitorios y servicios, garantizando una ventilación óptima mediante múltiples ductos de aire y luz. La construcción especifica acabados de calidad como carpintería de madera cedro y tornillo, además de sistemas de ventanas de aluminio con vidrio polarizado.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 10,
        "id": 13
    },
    {
        "identity": "pl-0023",
        "name": "Edificación multifamiliar de alta densidad",
        "category": "Departamento",
        "area": 270,
        "rooms": 18,
        "floors": 6,
        "front": 15,
        "depth": 18,
        "dimencion": "15x18",
        "price": 40,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915447/jqlhu7nsp8kuj5qcgqnq.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915468/p3baoolfmqigas15lbpb.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915478/lny9o2v6i8ksbvdt7n4e.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915487/i3vsecyn14oxtz0nmq8d.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915501/z7u5kerdxi1xlcz8xfaj.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Vida en comunidad con privacidad, Conexión con el exterior",
        "description": "Propuesta arquitectónica multifamiliar que contempla plantas típicas para el segundo, tercer y cuarto nivel, optimizando el uso del suelo mediante una distribución de departamentos por piso. Cada unidad habitacional cuenta con una zona social que integra sala-comedor con acceso a balcón, permitiendo una transición fluida hacia el exterior y una óptima iluminación. La distribución interna incluye dormitorios con clósets, cocinas funcionales y un núcleo de circulación central con hall y escaleras que conecta de manera independiente cada vivienda. El diseño aprovecha retiros y vacíos internos para asegurar ventilación natural en todos los ambientes.",
        "masVendidos": false,
        "level": 2,
        "style": "",
        "cantidLaminas": 6,
        "id": 14
    },
    {
        "identity": "pl-0024",
        "name": "Edificación de uso mixto de cinco niveles",
        "category": "Comercial",
        "area": 276,
        "rooms": 3,
        "floors": 5,
        "front": 12,
        "depth": 23,
        "dimencion": "12x23",
        "price": 20,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915821/hnm1mjlwef4zxvm51qis.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915840/js1wibdkgd9lr2btp908.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915847/auhdk7p7zpywljhlzxpq.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777915864/kixqdgoolvbjvcfbdvhx.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Inversión Integral y Privacidad Vertical",
        "description": "Complejo arquitectónico multifuncional que organiza sus niveles por especialidad para optimizar el flujo y la privacidad. El primer nivel está destinado exclusivamente a una galería comercial con múltiples tiendas independientes y una zona de servicios central. El segundo nivel se plantea como un centro de negocios con oficinas de diversos metrajes, accesibles mediante un núcleo de circulación con ascensor y escaleras de seguridad. Los niveles superiores (3°, 4° y 5°) albergan departamentos residenciales tipo dúplex y flats, que cuentan con sala-comedor, cocina con patio de servicio, dormitorios con baño privado y amplias terrazas o balcones que aseguran una excelente calidad de vida urbana.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 4,
        "id": 15
    },
    {
        "identity": "pl-0025",
        "name": "Edificio Multifamiliar con Comercio",
        "category": "Casa",
        "area": 160,
        "rooms": 4,
        "floors": 1,
        "front": 16,
        "depth": 10,
        "dimencion": "16x10",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "DWG",
            "PDF"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones",
            "Inst. Sanitarias",
            "Inst. Eléctricas",
            "Estructuras"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777916260/ktww2ctivfrrvvn5j9ri.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777916276/q3b2wfggm3lelyxyqlh4.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777916284/javvgjqjlzvfectoutqo.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777916292/ncwgfplmlq9yztkla5og.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777916304/evqdls4yvsw5mqvf1q2f.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Vivienda con Ingreso Propio, Distribución Optimizada",
        "description": "Propuesta integral de cinco niveles diseñada para lotes con frente a vía principal, optimizando cada metro cuadrado para uso comercial y residencial. El primer nivel ofrece una planta libre con amplio salón y servicios, ideal para locales comerciales de gran formato o cocheras. Del segundo al quinto nivel, el diseño se organiza mediante plantas típicas que albergan departamentos eficientes, cada uno con sala-comedor, cocina, dormitorios con clósets y baños independientes. La estructura destaca por su núcleo de escaleras central y una azotea técnica diseñada para facilitar el mantenimiento y la instalación de servicios. El uso de vacíos estratégicos garantiza iluminación y ventilación natural constante en todas las unidades habitacionales.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 7,
        "id": 16
    },
    {
        "identity": "pl-0026",
        "name": "Diseño Versátil: Espacio para Eventos Hogar Multifamiliar",
        "category": "Casa",
        "area": 350,
        "rooms": 6,
        "floors": 3,
        "front": 14,
        "depth": 25,
        "dimencion": "14x25",
        "price": 25,
        "type": "diseno",
        "packageType": "basico",
        "originalPrice": 35,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777916720/jpi9znmourskonx5iu9v.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777916727/yal2kr7gzputhjbicgaf.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777916750/vy0pppfqjsw6nx49s77g.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777916767/chnbbwsw098vkbokqa7t.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777916780/swmzdnrg4fnbtkmeicd3.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777916803/udl5ibg8fx756a7eadkq.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Negocio Propio en Casa, Privacidad para Familias Extensas",
        "description": "Propuesta arquitectónica de tres niveles diseñada para maximizar el uso de terrenos con geometría irregular. El primer nivel está configurado como un salón-local de planta abierta, equipado con un escenario, una barra de atención y servicios higiénicos independientes, ideal para eventos sociales o comerciales. Los niveles superiores (segundo y tercer nivel) se transforman en amplias áreas residenciales que albergan múltiples dormitorios, salas de estar (estar), cocinas equipadas y zonas de lavandería. El diseño incluye dormitorios principales con walk-in closet y baños privados, asegurando comodidad y privacidad. La circulación se resuelve mediante dos núcleos de escaleras laterales que permiten un flujo independiente entre los niveles.",
        "masVendidos": false,
        "level": 1,
        "style": "Moderno",
        "cantidLaminas": 8,
        "id": 17
    },
    {
        "identity": "pl-0027",
        "name": "Vivienda unifamiliar tres niveles",
        "category": "Departamento",
        "area": 82,
        "rooms": 5,
        "floors": 4,
        "front": 4,
        "depth": 20,
        "dimencion": "4x20",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917141/rxprjggzmievrv1wfdjk.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917147/aywz8tdrf7frdbn5b3fq.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917159/gir8qfio2anjmtryusmy.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917176/c3ekd3o8pf75ed47bpua.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917192/mdzi9y5l7hasqifidsjd.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917209/aydq0kiwxuiqrvvw7da4.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Distribución por Niveles, Espacios de Home Office",
        "description": "Propuesta residencial de tres niveles que maximiza el aprovechamiento de terrenos de sección reducida. El primer nivel integra una zona social de concepto abierto con sala, comedor y una cocina con barra desayunadora, además de un área de estacionamiento frontal. Los niveles superiores (segundo y tercer nivel) se destinan al área privada, albergando dormitorios con baños integrados y estudios independientes que facilitan el trabajo desde casa. La edificación destaca por su núcleo de escaleras lineal y el uso de mamparas de piso a techo que conectan visualmente los espacios interiores con los exteriores, garantizando ambientes luminosos y bien ventilados en toda la profundidad del lote.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 12,
        "id": 18
    },
    {
        "identity": "pl-0028",
        "name": "Edificación: Residencial y Estacionamiento - Multifamiliar",
        "category": "Departamento",
        "area": 96,
        "rooms": 6,
        "floors": 3,
        "front": 6,
        "depth": 15,
        "dimencion": "6x16",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917567/otefpqo64435ze6efdjq.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917579/lruwocz8y86rynuuir8o.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917597/awgintzrljpk8eyggqx4.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917611/wxzgn3nufyxkkraspko6.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917631/ibnw6lw7baih9tx7mceh.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Distribución de Tres Dormitorios, Capacidad Vehicular",
        "description": "Propuesta arquitectónica que organiza un programa residencial completo en tres niveles principales y una zona de servicios en la azotea. El primer piso está dedicado casi en su totalidad al estacionamiento, con capacidad para tres vehículos grandes, además de un ingreso peatonal con hall y escaleras. El segundo y tercer nivel presentan una planta típica que alberga departamentos con tres dormitorios, zona social integrada (sala-comedor), kitchenet y balcón frontal para mayor iluminación. La azotea corona el edificio con áreas de tendal independientes para cada unidad y una zona libre aprovechable. El diseño utiliza ductos de ventilación estratégicos para asegurar aire fresco en baños y áreas internas de servicio.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 13,
        "id": 19
    },
    {
        "identity": "pl-0029",
        "name": "Vivienda Unifamiliar Integral: Espacio, Confort y Terraza",
        "category": "Casa",
        "area": 90,
        "rooms": 6,
        "floors": 3,
        "front": 6,
        "depth": 15,
        "dimencion": "6x15",
        "price": 30,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917967/jzfffuvumnmlc7zfu5tv.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917974/byxyi02cfj4e2putmz7c.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917985/lmarjttuyuvwzptvxicy.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917999/n3jpo0bdxdkidvlt7z3n.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777918013/uwq4kqlbcadbwrgwaipq.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777918034/ia8slwutzjdjngzseuia.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Separación de Ambientes, Dormitorios Espaciosos",
        "description": "Propuesta de vivienda unifamiliar que distribuye de manera eficiente el programa residencial en tres plantas completas y una azotea funcional. El primer piso recibe al usuario con una cochera privada, un hall de ingreso, una sala espaciosa, comedor, cocina y un área de jardín posterior que asegura ventilación cruzada. El segundo y tercer nivel se consolidan como la zona privada, albergando dormitorios con balcones frontales y baños distribuidos estratégicamente para servir a cada piso. Finalmente, la azotea ofrece un área de lavandería, tendal y una amplia terraza diseñada para el esparcimiento social. El núcleo de escaleras lateral conecta todos los niveles de forma fluida, permitiendo un aprovechamiento máximo de la iluminación natural.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 7,
        "id": 20
    },
    {
        "identity": "pl-0030",
        "name": "Vivienda Multifamiliar: Densidad y Confort Social",
        "category": "Departamento",
        "area": 120,
        "rooms": 12,
        "floors": 4,
        "front": 6,
        "depth": 20,
        "dimencion": "6x20",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777918376/rhmlaq36mpyu32fenmh6.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777918389/bepugi9lpsompndftunl.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777918396/gftfxkkr7qdlfntulibz.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777918485/wsciyt8mx6y5el3nqsj8.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Independencia por Niveles, Distribución de Tres Dormitorios",
        "description": "Complejo residencial vertical de cinco niveles que organiza departamentos independientes con distribuciones eficientes por piso. El primer nivel establece el acceso principal mediante un hall y escaleras, integrando una zona social con sala, comedor, cocina y tres dormitorios, además de un patio posterior para ventilación. Los niveles superiores (del 2do al 5to piso) siguen plantas típicas que repiten la distribución de tres dormitorios y áreas sociales, maximizando el número de unidades habitacionales. La azotea se define como un área común de alta funcionalidad, equipada con una zona de parrilla, terraza social, sala de estar adicional y áreas de lavandería independientes. El diseño prioriza la iluminación natural a través de ductos laterales y patios internos que recorren toda la altura de la edificación.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 11,
        "id": 21
    },
    {
        "identity": "pl-0031",
        "name": "Edificio Multifamiliar: Amplitud Vertical y Diseño Funcional",
        "category": "Departamento",
        "area": 131,
        "rooms": 6,
        "floors": 4,
        "front": 7.5,
        "depth": 17,
        "dimencion": "7x17",
        "price": 20,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 30,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777931125/gqb8brueofffkjjhyoml.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777931146/uoaqlkp0xecuwqjxga3q.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777931230/zshvbifglsasn1jdt9sk.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Ambientes Saludables, Alturas Confortables",
        "description": "Documentación técnica que detalla la volumetría de un edificio residencial de cuatro niveles, donde se aprecia un diseño de planta típica desde el segundo hasta el cuarto piso. El Corte A-A permite observar la disposición de los vanos y la altura libre de cada departamento, mientras que el Corte B-B revela el diseño del núcleo de escaleras que conecta fluidamente todos los niveles hasta la azotea. La Elevación Principal muestra una fachada moderna con amplias ventanas y mamparas que garantizan una óptima iluminación natural y ventilación para cada unidad habitacional. El proyecto incluye una azotea funcional, diseñada para albergar áreas de servicio o recreación, protegida por parapetos que mantienen la estética del conjunto.",
        "masVendidos": false,
        "level": 1,
        "style": "Moderno",
        "cantidLaminas": 5,
        "id": 22
    },
    {
        "identity": "pl-0032",
        "name": "Vivienda unifamiliar de múltiples niveles",
        "category": "Casa",
        "area": 140,
        "rooms": 9,
        "floors": 4,
        "front": 7,
        "depth": 20,
        "dimencion": "7x20",
        "price": 50,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 60,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777932105/fnmjqarzvjxyphnxfvyp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777932130/xnzdmqhevs6j5trp5cgz.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777932406/p6fo32s1h2cr09iykhvn.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Vivienda con Jardines Interiores, Confort y Funcionalidad Profesional",
        "description": "Propuesta residencial que organiza un programa completo en un lote de 7.00 x 20.00 metros, priorizando la iluminación natural a través de terrazas y jardines estratégicos. El primer piso cuenta con un garaje privado, una zona social abierta con sala y comedor, cocina independiente y un dormitorio con vista a un jardín posterior. El segundo piso y los niveles superiores (3er y 4to piso típicos) se enfocan en la privacidad, ofreciendo un dormitorio principal con baño propio, dormitorios adicionales y un amplio estudio hacia la fachada principal. El diseño destaca por su núcleo de escaleras central y el uso de múltiples pozos de luz que garantizan ventilación en baños y áreas de servicio.",
        "masVendidos": false,
        "level": 1,
        "style": "Moderno",
        "cantidLaminas": 7,
        "id": 23
    },
    {
        "identity": "pl-0033",
        "name": "Vivienda Multifamiliar Eficiente: Espacios Amplios, Terrenos Irregulares",
        "category": "Casa",
        "area": 105.99,
        "rooms": 4,
        "floors": 3,
        "front": 8.5,
        "depth": 12.5,
        "dimencion": "8.5x12.5",
        "price": 30,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777931982/fgvet0l2quc5kvzrmlc3.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777931993/hwahbaxcx0hdlmlawmlb.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777932006/ns8ylafnwbicc5wibggs.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777932016/ckxqiiml5xo3txjaup8u.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777932025/ionjylcgszpciovx14ea.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Vivienda multifamiliar de tres niveles más azotea",
        "description": "Propuesta residencial que organiza departamentos completos en tres plantas, aprovechando la profundidad del lote para crear ambientes espaciosos. El primer piso integra una zona social de concepto abierto con sala y comedor, una cocina funcional y un dormitorio principal con baño privado y vestidor. El segundo y tercer piso presentan una planta típica que optimiza el espacio para albergar tres dormitorios, una zona de comedor central y una cocina independiente con lavandería integrada. La edificación remata en una azotea de planta libre que ofrece un gran potencial para áreas de esparcimiento o servicios comunes. El diseño utiliza un núcleo de escaleras con descanso en ángulo para adaptarse a la forma del terreno y garantizar un acceso cómodo a todos los niveles.",
        "masVendidos": false,
        "level": 1,
        "style": "Moderno",
        "cantidLaminas": 7,
        "id": 24
    },
    {
        "identity": "0034",
        "name": "Edificio Multifamiliar de 6 Niveles",
        "category": "Casa",
        "area": 165,
        "rooms": 9,
        "floors": 1,
        "front": 8.6,
        "depth": 20,
        "dimencion": "8x20",
        "price": 30,
        "type": "diseno",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777933131/nulkgsr9d46canaqeszy.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777933145/bb3bgljnoez9b7wjhagz.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777933152/nxsatcedkqltuwudld58.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777933160/fwygmgvkb8eyxvfqa9vm.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Departamentos Completos, Servicios Independientes",
        "description": "Propuesta arquitectónica integral que organiza un programa de alta densidad en seis niveles funcionales. El Primer Nivel se especializa en la recepción y el resguardo vehicular, contando con cinco amplias plazas de estacionamiento y un acceso peatonal seguro. Desde el Segundo hasta el Quinto Nivel, el edificio ofrece departamentos con una distribución inteligente que incluye dormitorios principales con walk-in closet, dormitorios secundarios y áreas sociales integradas. El Sexto Nivel destaca por su funcionalidad logística, albergando siete zonas de lavandería independientes, permitiendo que cada unidad del edificio gestione sus servicios de limpieza de forma privada y organizada. Todo el conjunto está conectado por un núcleo de escaleras central diseñado para una circulación fluida y segura.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 8,
        "id": 25
    },
    {
        "identity": "pl-0035",
        "name": "Vivienda Multifamiliar Moderna",
        "category": "Departamento",
        "area": 160,
        "rooms": 6,
        "floors": 4,
        "front": 8,
        "depth": 20,
        "dimencion": "8x20",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777933645/fslp40utef7fncog4c3j.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777933655/puunphaiexqxxiebs8v2.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777933665/t4qtsu9k5sasm0pqskoj.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777933673/prvoitpxhxq2igfo83n4.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Diseñada con un enfoque en la movilidad sostenible, Aprovechamiento de espacios",
        "description": "Propuesta residencial que organiza departamentos independientes con una distribución optimizada en cuatro plantas y una zona de esparcimiento en el último nivel. El Primer Piso se distingue por incluir un estacionamiento para dos vehículos y un área dedicada para bicicletas, promoviendo el transporte ecológico. Cada nivel residencial (del 1ro al 4to) alberga un departamento con tres dormitorios, zona social (sala-comedor), cocina y lavandería. El diseño incorpora generosos pozos de luz que garantizan la ventilación natural en todos los dormitorios y servicios. La Azotea corona el edificio con una sala de estar común, una amplia terraza frontal y áreas de servicio adicionales, ofreciendo un espacio de recreación al aire libre para los residentes.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 16,
        "id": 26
    },
    {
        "identity": "pl-0036",
        "name": "Vivienda Multifamiliar con Garage Integral",
        "category": "Departamento",
        "area": 160,
        "rooms": 6,
        "floors": 4,
        "front": 8,
        "depth": 20,
        "dimencion": "8x20",
        "price": 40,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934206/xhtsogpbaejmyo2wt8ts.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934213/qcjnmnaepgp4qesvgvxp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934227/hclhzoyk99noyb6xhzvx.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934238/kdffjdgei0lwklzek0xb.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934249/l7lbdcuskcz3hxyhdqnu.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Capacidad de Estacionamiento",
        "description": "Edificación residencial que optimiza un terreno de planta alargada mediante una distribución vertical clara y funcional. El Primer Piso se proyecta como una zona de servicios y estacionamiento, contando con un extenso área de garage con capacidad para múltiples vehículos, además de patios posteriores para ventilación y un depósito estratégico. A partir del Segundo Nivel, el edificio alberga departamentos completos que incluyen áreas sociales (sala, comedor), cocina, estudio y dormitorios con baños integrados. La circulación vertical está garantizada por una escalera central que conecta todos los niveles hasta la Azotea, la cual funciona como un espacio abierto versátil con áreas de tendido y esparcimiento.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 11,
        "id": 27
    },
    {
        "identity": "pl-0037",
        "name": "Edificio Multifamiliar Residencial",
        "category": "Departamento",
        "area": 200,
        "rooms": 3,
        "floors": 3,
        "front": 10,
        "depth": 20,
        "dimencion": "10x20",
        "price": 50,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 70,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Estructuras",
            "Arquitectura",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934465/cahusinxy8a2pkkutvk6.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934476/qr3l3qhwpklmtsb8gqqi.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934489/zyysbpdk4uie249pzf9j.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934501/krunugcphkgdmza7osa4.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934513/emifpcr09rkpnkihpunp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Simetría Funcional, propuesta de alta densidad y diseño simétrico",
        "description": "El complejo residencial Ingeniería A&P organiza un programa de cinco niveles habitables con una distribución de dos departamentos por piso, sumando un total de 9 unidades inmobiliarias. El Primer Piso funciona como el núcleo logístico, ofreciendo cuatro plazas de estacionamiento (01 al 04), un depósito y el departamento 101, que incluye áreas de estudio y patios privados. Del Segundo al Cuarto Piso, el diseño se duplica en un espejo perfecto, albergando los departamentos 201-202, 301-302 y 401-402, cada uno con dormitorios principales y secundarios, zonas de estar y balcones hacia la fachada. El Quinto Piso culmina el edificio con los departamentos 501 y 502, los cuales se benefician de amplios patios de servicio posteriores, garantizando una ventilación óptima en la parte más alta de la edificación.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 19,
        "id": 28
    },
    {
        "identity": "pl-0038",
        "name": "Vivienda Multifamiliar Premium: Amplitud y Servicios Completos",
        "category": "Departamento",
        "area": 280,
        "rooms": 4,
        "floors": 1,
        "front": 11,
        "depth": 26,
        "dimencion": "",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934802/c7lxczovootlyikmhchk.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934821/onlyokmwnwfrwsfaujxy.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777934832/jjx117whuv44v5ywnd27.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Gestión Vehicular Superior, Privacidad en Áreas de Servicio",
        "description": "Esta edificación residencial propone una estructura jerarquizada para ofrecer la máxima comodidad y funcionalidad. El Semisótano está dedicado exclusivamente a la logística, con un amplio estacionamiento con capacidad para seis vehículos, área de maniobras, depósitos individuales y un cuarto de bombas. El Primer Nivel combina elegancia con utilidad, presentando una entrada con jardín, amplias zonas sociales (sala, comedor), cocina con despensa y dormitorios con terrazas privadas. Los niveles superiores, como el Segundo y Tercer Nivel, organizan departamentos de gran escala que cuentan con múltiples dormitorios (principal y secundarios), áreas de servicio completas con cuarto de servicio y lavandería, y balcones con diseño curvo en la fachada frontal. La distribución se completa con un Nivel de Techos que asegura la protección climática de toda la estructura.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 5,
        "id": 29
    },
    {
        "identity": "pl-0039",
        "name": "Edificio Multifamiliar con Semisótano",
        "category": "Departamento",
        "area": 240,
        "rooms": 0,
        "floors": 6,
        "front": 12,
        "depth": 20,
        "dimencion": "12x20",
        "price": 100,
        "type": "plano",
        "packageType": "Completo",
        "originalPrice": 150,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones",
            "Inst. Gas"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935067/zx0zdeysk9rwqxnmnxrl.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935080/dvdelfycngp4zc5isint.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935089/z89sshnmqubvchjadask.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935100/oaetulpwhlr45o2gvc5d.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935110/kjihmrnznkzg9ecwihri.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Premium",
        "bonus": "",
        "idealFor": "Edificio Multifamiliar con Semisótano",
        "description": "El proyecto se estructura en seis niveles habitables más un semisótano técnico. El Semisótano maximiza el área de estacionamiento con capacidad para 12 vehículos y un patio de maniobras central. En el Primer Nivel, se ubican los departamentos 101 y 102, que cuentan con patios interiores y acceso directo desde el hall de ingreso, además de tres plazas de estacionamiento adicionales en el frente. Las Plantas Típicas (2° al 5° piso) albergan dos departamentos por nivel, mientras que el Sexto Piso culmina con unidades que integran amplias terrazas frontales para disfrutar de la vista urbana.",
        "masVendidos": true,
        "level": 4,
        "style": "Moderno",
        "cantidLaminas": 32,
        "id": 30
    },
    {
        "identity": "pl-0040",
        "name": "Edificio Multifamiliar de Alta Densidad",
        "category": "Departamento",
        "area": 378,
        "rooms": 8,
        "floors": 5,
        "front": 14,
        "depth": 27,
        "dimencion": "14x27",
        "price": 30,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935451/xn3q6nrcqwjclap6gbec.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935474/wbhpaszssvxons1zpclg.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935487/fmr5s8p1fvd6cxbsfvro.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935498/viqsqawwefgt57dfoki4.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935507/d08quau79wg38zx2hebx.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Distribución de Tres Unidades por Piso, Dormitorios Funcionales",
        "description": "El diseño se organiza a través de niveles especializados para separar las funciones logísticas de las residenciales. El Planta Semi-sótano está dedicado íntegramente al estacionamiento, con capacidad para albergar al menos 12 vehículos, e incluye áreas de recepción, depósitos y núcleos de circulación vertical. El Primer Piso introduce las primeras unidades de vivienda, mientras que de la Planta 2do al 4to Piso y la Planta 3er Piso se proponen distribuciones típicas que maximizan el número de dormitorios por departamento, utilizando pozos de luz estratégicos para asegurar la ventilación en todo el bloque.",
        "masVendidos": false,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 6,
        "id": 31
    },
    {
        "identity": "pl-0041",
        "name": "Lujo y Recreación: Un Oasis Urbano en Casa",
        "category": "Hotel",
        "area": 680,
        "rooms": 12,
        "floors": 5,
        "front": 18,
        "depth": 38,
        "dimencion": "18x38",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935757/vskb6cvq276nt2zfoywe.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935776/dxg0yhylb91pjgnx2hpd.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935784/fsxnzjliorne38hqdhso.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Zona de Lounge y Piscina, Distribución Inteligente",
        "description": "El proyecto se define por su versatilidad y lujo funcional. El nivel de Sótano está diseñado para una gestión vehicular impecable, ofreciendo múltiples plazas de estacionamiento numeradas y un núcleo de acceso seguro con escaleras y ascensor. El Primer Nivel se transforma en el corazón social de la vivienda, destacando una espectacular piscina circular integrada en un patio posterior con terraza, ideal para el entretenimiento. Los niveles superiores, del 2do al 4to Nivel, organizan áreas residenciales privadas que mantienen la fluidez del diseño y aseguran vistas privilegiadas hacia los espacios abiertos del complejo.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 4,
        "id": 32
    },
    {
        "identity": "pl-0042",
        "name": "Edificio de Departamentos con Estacionamiento Integrado",
        "category": "Departamento",
        "area": 390,
        "rooms": 6,
        "floors": 3,
        "front": 22,
        "depth": 18,
        "dimencion": "22x18",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "DWG",
            "PDF"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936021/t22i3hazmuvjvd9eetij.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936034/fquhi13qmdzi2tlbsrwl.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936046/hl8xpdodtkccdlrq2adx.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936063/oqeek26ajo9kwsxqwo0a.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Eficiencia Residencial y Logística Vehicular",
        "description": "La edificación se distribuye en niveles claramente diferenciados para separar la zona técnica de la habitacional. La Distribución del 1° Piso está dedicada íntegramente al Estacionamiento de Vehículos, contando con una rampa de acceso, amplias plazas de parqueo y áreas de maniobra, además de zonas de servicios como cuarto de limpieza. La Distribución del 2° y 3° Piso organiza múltiples unidades de vivienda independientes conectadas por un pasillo central y un núcleo de escaleras. El proyecto culmina con la Distribución de Azotea, un espacio abierto que permite la ventilación de los ductos internos y ofrece potencial para áreas comunes de esparcimiento.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 0,
        "id": 33
    },
    {
        "identity": "pl-0043",
        "name": "Edificio Multifamiliar de 4 Niveles",
        "category": "Departamento",
        "area": 200,
        "rooms": 6,
        "floors": 4,
        "front": 10,
        "depth": 20,
        "dimencion": "10x20",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936319/ysptmclbvel2pghmwcq4.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936336/zvw1140zysuk3op2mnva.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936347/faaqvuvputpol3wmkbzb.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936364/rvsl5qplrwjsky0nkg9i.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Vivienda Multifamiliar: Simetría, Confort y Espacios Verdes",
        "description": "La edificación se estructura en dos plantas habitables con departamentos independientes que comparten un núcleo de circulación central. La Planta 1° Piso integra cuatro plazas de estacionamiento privadas (dos a cada extremo) y un área técnica que incluye una cisterna enterrada para garantizar el suministro de agua. La Planta 2° Piso replica la distribución de los departamentos 201 y 202, eliminando las zonas de parqueo para maximizar el área habitable y ofreciendo vistas hacia los jardines del primer nivel.",
        "masVendidos": false,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 6,
        "id": 34
    },
    {
        "identity": "pl-0044",
        "name": "Edificio de Uso Mixto con Infraestructura Deportiva",
        "category": "Departamento",
        "area": 210,
        "rooms": 3,
        "floors": 3,
        "front": 14,
        "depth": 15,
        "dimencion": "14x15",
        "price": 10,
        "type": "diseno",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936667/feerfaiz21pjxiwsx40a.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936678/l79up0qdgjowrx1lmfcl.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Integración Comercial",
        "description": "El proyecto se basa en una estructura sólida definida en el plano de cimientos. Incluye un sótano con dos canchas deportivas y circulaciones, una planta baja con tres tiendas, acceso principal y estacionamiento, y dos pisos superiores con departamentos completos, terrazas y áreas sociales.",
        "masVendidos": false,
        "level": 1,
        "style": "Clásico",
        "cantidLaminas": 2,
        "id": 35
    },
    {
        "identity": "pl-0045",
        "name": "Edificio Multifamiliar Estrecho",
        "category": "Departamento",
        "area": 143,
        "rooms": 6,
        "floors": 4,
        "front": 6.5,
        "depth": 22,
        "dimencion": "6.5x22",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936920/uplpylgdyqqbx24qd59l.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936936/ugciik2brhzydrhbkrkl.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936952/ujr9dvnp4nqhlnkxlcjr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Distribución de Tres Dormitorios, Zona Social Integrada",
        "description": "El proyecto se desarrolla en tres niveles principales que optimizan cada metro cuadrado del terreno. La 1ra Planta Distribución combina un ingreso vehicular con estacionamiento frontal, una tienda comercial amplia y una zona de servicios posterior que incluye un patio de máquinas. La 2da y 3ra Planta Distribución están dedicadas íntegramente a la vivienda, configurando departamentos que se extienden a lo largo del lote, conectados por una galería de circulación lateral y una escalera de acceso independiente desde el primer nivel.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 5,
        "id": 36
    },
    {
        "identity": "pl-0046",
        "name": "Edificio de Uso Mixto: Comercial, Oficinas y Residencia",
        "category": "Departamento",
        "area": 175,
        "rooms": 12,
        "floors": 4,
        "front": 7,
        "depth": 25,
        "dimencion": "7x25",
        "price": 30,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777938146/nesevg4uknwngz3qhm43.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777938157/duoxlgbsgh5xnjl5m64k.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777938173/taqufhen0mylqehcxmnp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777938182/yqswjr30tcfdyncowbdi.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Departamentos Optimizados, Áreas de Trabajo Independientes",
        "description": "El edificio se organiza en niveles especializados para maximizar la funcionalidad de cada metro cuadrado. La Primera Planta está dedicada al sector comercial, con un amplio espacio de Comercio, un ingreso independiente y una zona residencial posterior que incluye un dormitorio principal y terraza. La Segunda Planta introduce un área de Oficina frontal y departamentos independientes hacia el interior. La Tercera y Cuarta Planta se consolidan como niveles residenciales típicos, ofreciendo departamentos con áreas sociales y kitchenette. El proyecto culmina en la Azotea, un nivel técnico y de servicios con amplios vacíos de iluminación.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 7,
        "id": 37
    },
    {
        "identity": "pl-0047",
        "name": "Vivienda Multifamiliar Optimizada",
        "category": "Departamento",
        "area": 144,
        "rooms": 8,
        "floors": 4,
        "front": 8,
        "depth": 18,
        "dimencion": "8x18",
        "price": 30,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "DWG",
            "PDF"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777938531/oe2eoxcwrblsjgikgqae.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777938548/ukig9mwgf6qwtu44qqju.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777938555/f0y6d1elyvfylvzus4cr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777938570/i0vbeaf9jxo9vqbdj5kt.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Zona Social Integrada, Área Privada Completa",
        "description": "La edificación se estructura en plantas con propósitos diferenciados para maximizar el uso del terreno. La Planta 1° Piso funciona como el núcleo de acceso y servicios, integrando dos plazas de estacionamiento, un ingreso principal con depósitos y el Departamento A, el cual cuenta con un jardín interior privado. Las plantas superiores (Planta Típica 2°, 3° y 4° Piso) albergan el Departamento B, que replica una distribución eficiente orientada a la vida familiar, sustituyendo el área de estacionamiento por una jardinera frontal y optimizando la iluminación mediante pozos de luz.",
        "masVendidos": false,
        "level": 1,
        "style": "Minimalista",
        "cantidLaminas": 12,
        "id": 38
    },
    {
        "identity": "pl-0048",
        "name": "Edificio de Vivienda Multifamiliar con Comercio",
        "category": "Departamento",
        "area": 154,
        "rooms": 12,
        "floors": 3,
        "front": 11,
        "depth": 14,
        "dimencion": "11x14",
        "price": 30,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777938948/y776oqxos19wauc0kynh.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777938958/p6asseevibilguydyidk.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777938964/pyq5qjvi9fectxbx8rkj.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Núcleo de Circulación Vertical, diseñado con una volumetría moderna",
        "description": "La edificación se distribuye estratégicamente para separar las actividades comerciales de las residenciales. El Primer Nivel está dedicado íntegramente al uso comercial, con dos amplios espacios de Trastienda y áreas de Comercio que flanquean un hall de ingreso central equipado con ascensor. El Segundo y Tercer Nivel albergan departamentos tipo, cada uno con sala, comedor, cocina, lavandería y dormitorios. Finalmente, la Azotea ofrece un área de Terraza abierta, ideal para actividades recreativas al aire libre.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 6,
        "id": 39
    },
    {
        "identity": "pl-0049",
        "name": "Vivienda Multifamiliar",
        "category": "Casa",
        "area": 112,
        "rooms": 6,
        "floors": 3,
        "front": 7,
        "depth": 16,
        "dimencion": "7x16",
        "price": 10,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939294/dy0mxmcknw5zfhqw2oxe.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939305/yshrqwlorwgmszds8wda.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939314/dx1bqk2p1ehmvlownafp.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Distribución de Tres Dormitorios, Áreas Sociales Fluídas",
        "description": "El proyecto se desarrolla en cinco niveles más azotea, segmentando las funciones por planta para asegurar la privacidad y eficiencia operativa. El 1er Piso combina el acceso principal con una Tienda hacia la fachada y un departamento posterior de tres dormitorios. El 2do Piso y la planta típica del 3er al 5to Piso presentan departamentos completos de tres dormitorios con áreas sociales integradas. El edificio corona con una Azotea destinada a servicios comunes como la Lavandería.",
        "masVendidos": false,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 3,
        "id": 40
    },
    {
        "identity": "pl-0050",
        "name": "Edificio Multifamiliar con Semisótano",
        "category": "Departamento",
        "area": 300,
        "rooms": 6,
        "floors": 3,
        "front": 12,
        "depth": 25,
        "dimencion": "12x25",
        "price": 30,
        "type": "diseno",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939629/gccbxdxaucrakmbd8vsx.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939641/zgrdqiklahoxypbjceie.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939648/qin0d4psir2f3qlnnzdf.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939656/u31yu3pw03zya8rghhh1.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Zona Social Amplia, Distribución de Dormitorios",
        "description": "El proyecto se organiza desde un nivel de Semisótano diseñado principalmente para el resguardo de vehículos, contando con seis plazas de estacionamiento y depósitos técnicos. La edificación asciende a través de una Planta Primer Piso que combina accesos vehiculares adicionales con una unidad de vivienda, seguida de una Planta Típica (2do y 3er Piso) y un Cuarto Piso con distribuciones residenciales optimizadas. El edificio culmina en una Planta Azotea y una planta de techos que alberga el cuarto de máquinas para el ascensor.",
        "masVendidos": false,
        "level": 1,
        "style": "Moderno",
        "cantidLaminas": 8,
        "id": 41
    },
    {
        "identity": "pl-0051",
        "name": "Galería Comercial",
        "category": "Comercial",
        "area": 250,
        "rooms": 1,
        "floors": 4,
        "front": 10,
        "depth": 25,
        "dimencion": "10x25",
        "price": 20,
        "type": "diseno",
        "packageType": "Intermedio",
        "originalPrice": 30,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939887/c3ppxsrc5jqjeki1ewbh.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939897/tb3xowh8fk8hbbat4rsr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939904/jqv2bes6mpm91l32qorc.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939912/sj8pam7jkjenkpppzm43.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Pasaje de Circulación, Ingreso Principal",
        "description": "El diseño de la planta baja se organiza simétricamente a lo largo de un eje central, albergando un total de ocho tiendas comerciales numeradas de la 101 a la 108. Cada tienda cuenta con un área promedio de entre 16.80 $m^2$ y 18.87 $m^2$ aproximadamente, optimizando el espacio para diversos tipos de negocios minoristas. Además, cada local incluye su propio núcleo de servicios higiénicos y ductos de ventilación independientes para asegurar la autonomía operativa.",
        "masVendidos": false,
        "level": 1,
        "style": "Minimalista",
        "cantidLaminas": 0,
        "id": 42
    },
    {
        "identity": "pl-0052",
        "name": "Unifamiliar con Áreas Recreativas",
        "category": "Departamento",
        "area": 270,
        "rooms": 6,
        "floors": 3,
        "front": 9,
        "depth": 30,
        "dimencion": "9x30",
        "price": 30,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Inst. Eléctricas",
            "Estructuras",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777947626/edmzkybaawl9hqmowx5v.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777947638/xnqs19w2reqwysu72emd.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777947645/rypi89jdqvo1xvppszcn.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777947654/cju62xfpzinssmjfighj.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Espacios de Entretenimiento Intimo",
        "description": "La Distribución 1° Piso se organiza para separar las actividades de servicio y trabajo de las de descanso y ocio. Al frente se ubica un Car-Port con capacidad para dos vehículos, contiguo a un Estudio y una Biblioteca que flanquean el ingreso principal. El núcleo social destaca por una Sala y Comedor integrados que conectan directamente con una Terraza exterior y una Piscina, rodeada de áreas de circulación. Hacia la zona posterior, se sitúa un Dormitorio Principal con vestidor y un Dormitorio de Hija, complementados por un área de servicios que incluye cocina, lavandería y depósito",
        "masVendidos": true,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 10,
        "id": 43
    },
    {
        "identity": "pl-0053",
        "name": "Proyecto de Uso Mixto: Comercio y Vivienda Multifamiliar",
        "category": "Casa",
        "area": 108,
        "rooms": 4,
        "floors": 3,
        "front": 6,
        "depth": 18,
        "dimencion": "6x18",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777947977/m1srk8mnvzrymhkhgn4q.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777947997/afkxty2tf4stj6pnafnn.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777948003/d6suj7dfaihc9etkh0uk.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777948011/x80afwyanwecq6d9lvxa.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Edificio de Uso Mixto, Zona Residencial Privada",
        "description": "La edificación se distribuye para separar claramente las actividades económicas de la vida privada. El 1er Piso cuenta con un Local Comercial frontal, depósitos y un patio posterior. El 2do Piso funciona como el núcleo social y familiar, albergando la sala, comedor, cocina y el Dormitorio-01. El 3er Piso se dedica exclusivamente al descanso con los Dormitorios 03, 04 y 05, además de una sala de estar. El proyecto culmina en la Azotea, que integra el área de lavandería, y una Planta de Techo con zona de tendal.",
        "masVendidos": true,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 15,
        "id": 44
    },
    {
        "identity": "pl-0054",
        "name": "Vivienda Unifamiliar de Lujo",
        "category": "Casa",
        "area": 200,
        "rooms": 3,
        "floors": 3,
        "front": 10,
        "depth": 20,
        "dimencion": "10x20",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777948374/kokpssvle6fdx3yykui6.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777948386/m191m0dtqclsbypdcjpe.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777948401/wvumfciluwkgxxidcq1o.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777948416/rxi72vbkj9re1qflmzke.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "Plano Conexión de tv Internet",
        "idealFor": "Zona Recreativa Frontal",
        "description": "La vivienda se desarrolla sobre un terreno de 200.00 $m^2$, logrando una distribución funcional que separa las actividades sociales y de servicio de las áreas privadas. El 1er Nivel funciona como el núcleo de vida social y exterior, incluyendo una piscina, terraza, sala y comedor, además de áreas de servicio como la cocina y lavandería. El 2do Nivel se reserva para la zona íntima, con dormitorios que cuentan con clósets y baños privados, además de una terraza que balconea hacia el primer piso.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 20,
        "id": 45
    },
    {
        "identity": "pl-0055",
        "name": "Edificio Unifamiliar: Eficiencia en Espacios Estrechos",
        "category": "Casa",
        "area": 147,
        "rooms": 9,
        "floors": 3,
        "front": 7,
        "depth": 21,
        "dimencion": "7x21",
        "price": 35,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Inst. Sanitarias",
            "Inst. Eléctricas",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777948697/daoxa3u05sr1d3sqlmjo.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777948721/z15dakckvcpmtwl7crdd.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777948733/y6fs6po9mtzpbzfep5vq.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777948745/vcxked18n5qbincgxfif.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Distribución Privada, Circulación Vertical",
        "description": "La vivienda se estructura para maximizar la profundidad del terreno, separando las áreas de servicio y sociales de las zonas más íntimas. La 1era Planta integra el acceso vehicular a través de una Cochera, seguida de una cocina, baño y un amplio Salón que ocupa la parte posterior del lote. La 2da Planta concentra el área residencial con tres dormitorios, un comedor central, cocina, lavandería y un balcón frontal. El proyecto culmina en el nivel de Techos, que ofrece una amplia Azotea libre para usos recreativos o de mantenimiento.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 5,
        "id": 46
    },
    {
        "identity": "pl-0056",
        "name": "Residencia Multifamiliar con Piscina y Áreas Sociales",
        "category": "Casa",
        "area": 260,
        "rooms": 10,
        "floors": 2,
        "front": 13,
        "depth": 20,
        "dimencion": "13x20",
        "price": 40,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777949166/jp1wotejntgk4wyibxzl.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777949188/fwqrxcvfnlbrz9cyr7wh.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777949330/ickwemlftazozhvib7eo.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777949342/aa6euoet3dmt7lyy6v5r.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "Inst Aire Acondicionado",
        "idealFor": "Configuración de Dormitorios, Vivienda Multifamiliar",
        "description": "La Distribución Primer Nivel destaca por su enfoque en el bienestar y el entretenimiento privado. El acceso incluye un Estacionamiento y un área de Oficina cerca del ingreso principal. La zona social integra una Sala y Comedor con vista a una Piscina de $5.55$ m de largo, rodeada de una Terraza y áreas verdes. En este nivel también se ubican el Dormitorio Principal con clóset, un Dormitorio de Visita y dos dormitorios adicionales en la parte posterior, sumando un total de cuatro habitaciones en la planta baja.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 18,
        "id": 47
    },
    {
        "identity": "pl-0057",
        "name": "Edificio Residencial Multifamiliar",
        "category": "Departamento",
        "area": 220,
        "rooms": 6,
        "floors": 5,
        "front": 11,
        "depth": 20,
        "dimencion": "11x20",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777949745/xxwsxr1bh0bx9ygva8mt.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777949755/ikgwmsrsh7ycrdqmallk.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777949762/afy931tigg0kgkymg624.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777949772/rlb2lirhktrwanpozw2e.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "inst de conexión de Red TV",
        "idealFor": "Distribución Funcional por Niveles, Atributos de Confort y Diseño",
        "description": "Este diseño arquitectónico para una Residencia de Dos Niveles destaca por su organización funcional que separa eficientemente las áreas de servicio y sociales de los espacios de ocio y descanso.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 11,
        "id": 48
    },
    {
        "identity": "pl-0058",
        "name": "Vivienda Unifamiliar de Dos Niveles",
        "category": "Departamento",
        "area": 250,
        "rooms": 4,
        "floors": 2,
        "front": 10,
        "depth": 25,
        "dimencion": "10x25",
        "price": 30,
        "type": "diseno",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777950062/cuv3fbyrish3y4skncfp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777950076/qfqlypjiz097pgstiso0.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777950086/kj3kbxacxawnmo9gmcne.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777950099/rlubcbtqcnog8pkdxfpp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Ingreso y Estacionamiento, Zona Social",
        "description": "Este diseño arquitectónico para una Vivienda Unifamiliar de Dos Niveles propone una distribución moderna que integra espacios abiertos, jardines interiores y una fachada contemporánea con techos inclinados.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 5,
        "id": 49
    },
    {
        "identity": "pl-0059",
        "name": "Unifamiliar de Alta Capacidad: Máxima Eficiencia Habitacional",
        "category": "Casa",
        "area": 200,
        "rooms": 12,
        "floors": 2,
        "front": 10,
        "depth": 20,
        "dimencion": "10x20",
        "price": 30,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777950449/kt2e41cslx8vjmwsbtjq.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777950481/guv8l5ju1ewskz9uue7b.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777950500/athk2e6lcjyaqrmipaad.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777950591/tpn7ooalfyjkjfq4b5uj.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Proyecto de Vivienda de Renta Extensiva, Residencia Estudiantil/Laboral",
        "description": "Para elevar el valor comercial de este diseño en tu catálogo, podrías sugerir una variante donde algunas de las habitaciones del segundo nivel se unan para crear una Suite Principal con baño privado y walk-in closet, o transformar una de las habitaciones frontales del primer nivel en un estudio u oficina con acceso directo, adaptándolo a las necesidades actuales de trabajo remoto sin perder su capacidad habitacional.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 6,
        "id": 50
    },
    {
        "identity": "pl-0060",
        "name": "Vivienda de Uso Mixto",
        "category": "Comercial",
        "area": 160,
        "rooms": 4,
        "floors": 3,
        "front": 10,
        "depth": 16,
        "dimencion": "10x16",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "DWG",
            "PDF"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777951084/abqsefaqqfkkjfdqcolx.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777951106/zxxsjvjxegsfpb0bkjod.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777951187/rgp05js7pclyub1gunvl.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Proyecto de Vivienda-Taller",
        "description": "Este diseño es ideal para ser promovido como un Proyecto de Vivienda-Taller. La planta baja libre permite el desarrollo de un negocio propio (como una oficina técnica, estudio de diseño o showroom) manteniendo la privacidad absoluta de la vivienda en los niveles superiores. Para maximizar el impacto de la elevación, se recomienda el uso de iluminación LED perimetral en los marcos rojos de las ventanas para destacar el volumen durante la noche",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 7,
        "id": 51
    },
    {
        "identity": "pl-0061",
        "name": "Residencia Multifuncional con Local Comercial y 5 Dormitorios",
        "category": "Casa",
        "area": 160,
        "rooms": 6,
        "floors": 2,
        "front": 10,
        "depth": 16,
        "dimencion": "10x16",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777952447/njjyy9lvdjikmwc7hjn2.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777952456/wlfyctio2mdfjfmqgvut.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777952461/kqbkcmu4zcbolf9tnsq0.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777952475/ogzfuef1teuwdb0yylt3.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "local comercial y taller independiente, familias numerosas",
        "description": "Este diseño integral de tres niveles está optimizado para maximizar la rentabilidad y el confort en un solo lote, enfocado en la productividad, cuenta con un amplio local comercial (tienda) independiente, un área de taller/garaje de gran capacidad, y una zona social con sala, comedor diario y cocina",
        "masVendidos": false,
        "level": 3,
        "style": "",
        "cantidLaminas": 6,
        "id": 52
    },
    {
        "identity": "pl-0062",
        "name": "Residencia Unifamiliar Moderna con Piscina y Áreas Sociales Integradas",
        "category": "Casa",
        "area": 190,
        "rooms": 6,
        "floors": 3,
        "front": 9,
        "depth": 21,
        "dimencion": "9x21",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 500,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778034373/oeneq99i1xswdzb8tqgp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778034387/v8w0kjws7oabwcymjweq.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778034395/njzmsrfd9bpnocdjcomv.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778034406/pasdqjqf3wn572958ujh.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "Plano Aligerados",
        "idealFor": "Familias en crecimiento, Inversionistas inmobiliarios",
        "description": "Este diseño arquitectónico integral optimiza un lote urbano a través de cuatro niveles claramente zonificados para el confort familiar. La Primera Planta destaca por un área social fluida que incluye sala, comedor y una cocina funcional, conectando directamente con una zona de esparcimiento posterior equipada con piscina y jardín. Los niveles superiores están destinados a la privacidad y el servicio: la Segunda Planta alberga tres dormitorios con balcones independientes , mientras que la Tercera Planta añade versatilidad con un cuarto de visitas, lavandería y una amplia terraza frontal. El proyecto culmina en una Azotea técnica y social, ofreciendo una solución habitacional completa, moderna y de alta plusvalía.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 10,
        "id": 53
    },
    {
        "identity": "pl-0063",
        "name": "Residencia Multinivel Optimizada con Semisótano y Distribución Funcional",
        "category": "Casa",
        "area": 90,
        "rooms": 6,
        "floors": 4,
        "front": 9,
        "depth": 10,
        "dimencion": "9x10",
        "price": 40,
        "type": "diseno",
        "packageType": "Intermedio",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "DWG",
            "PDF"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778034857/orrupiilxqlnuimoq8f6.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778034868/hlaqlixludzy95hqiwm9.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778034874/t9dxqvfyxtl3yobjbl7s.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778034883/ve0if11l8xjroavyezyh.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Terrenos con desnivel o necesidades de espacio extra, Familias que buscan privacidad",
        "description": "Este proyecto arquitectónico presenta una solución habitacional de alta eficiencia distribuida en tres niveles principales más un área de servicios. La propuesta destaca por la inclusión de una Planta Semisótano de planta libre, ideal para estacionamiento múltiple o grandes áreas de almacenamiento. En la Primera Planta, el diseño integra una sala de estar y comedor de concepto abierto, una cocina con acceso directo a la lavandería y un patio posterior con áreas verdes que favorecen la iluminación natural. Finalmente, la Segunda Planta está dedicada a la zona privada, contando con tres dormitorios espaciosos: un dormitorio principal (Dormitorio 1) con baño privado y dos dormitorios secundarios (Dormitorio 2 y 3) con acceso a balcones y visuales externas, garantizando ventilación cruzada y confort térmico en todos sus ambientes.",
        "masVendidos": false,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 10,
        "id": 54
    },
    {
        "identity": "pl-0064",
        "name": "Vivienda Unifamiliar Funcional con Garaje Integrado ",
        "category": "Casa",
        "area": 144,
        "rooms": 6,
        "floors": 3,
        "front": 8,
        "depth": 18,
        "dimencion": "8x18",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778035170/aczpmznbrahuwkiet8gv.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778035180/b7diayfalxduahyicq3n.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778035185/gfrv2pvtcpuywfo3u7cs.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778035261/eeeptyqmlr4ifa4wa1kt.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"

        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias numerosas en lotes urbanos, Proyectos de vivienda con garaje privado",
        "description": "Este diseño destaca por su excelente aprovechamiento del espacio en un lote alargado, logrando una distribución equilibrada entre áreas sociales y privadas en dos niveles. En el 1° Piso, la vivienda cuenta con un garaje frontal, una sala-comedor integrada y una cocina con barra que conecta a un patio de lavandería central, garantizando iluminación natural en el corazón de la casa. El nivel también incluye un dormitorio principal con baño propio y un dormitorio secundario con vista al jardín posterior. El 2° Piso eleva el confort con una amplia sala de estar íntima y tres dormitorios adicionales, organizados en torno a un hall central. Finalmente, la Azotea ofrece un área libre de gran formato, ideal para futuras ampliaciones o una zona de terraza social, complementada con un patio de lavandería adicional.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 6,
        "id": 55
    },
    {
        "identity": "pl-0065",
        "name": "Residencia Unifamiliar de Estilo Abierto con Master Suite y Patio Social",
        "category": "Casa",
        "area": 120,
        "rooms": 4,
        "floors": 3,
        "front": 8,
        "depth": 15,
        "dimencion": "8x15",
        "price": 30,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778035521/tx0e1ookmahcjghnv4pq.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778035532/ncldyo52esj3i26uzamf.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778035540/wrw1xdlj6c1nkmstj58l.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778035549/a6s6eveeturmwde139kf.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Anfitriones y vida social, Lotes urbanos de profundidad media",
        "description": "Este proyecto destaca por una planta baja de concepto abierto que integra de forma fluida la sala, el comedor y una cocina de gran formato con isla, ideal para la convivencia moderna. El Primer Piso incluye un garaje privado, un dormitorio versátil y un amplio patio posterior que abarca todo el ancho del lote, asegurando ventilación natural en todos los niveles. En el Segundo Piso, la distribución prioriza el confort con una sala de estar íntima y tres dormitorios, resaltando la habitación principal que cuenta con un vestidor independiente y baño privado con tina. Finalmente, el nivel de Azotea optimiza la funcionalidad con un área de lavandería, un dormitorio de servicio con baño propio y una extensa terraza libre para usos múltiples.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 4,
        "id": 56
    },
    {
        "identity": "pl-0066",
        "name": "Vivienda Multifamiliar de Diseño Compacto ",
        "category": "Casa",
        "area": 120,
        "rooms": 5,
        "floors": 1,
        "front": 8,
        "depth": 15,
        "dimencion": "8x15",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 60,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778035791/pz8zxng4nhihw4bmydmu.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778035814/tto70vqhiwnnugxr9xld.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778035940/sfo0hzeqwp9blzvyo8qd.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778035956/j9hnspjsdea9yaudfi8z.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias que requieren múltiples habitaciones",
        "description": "Proyecto arquitectónico de tres niveles con distribución eficiente que optimiza cada metro cuadrado. El primer piso integra zona social abierta, cocina con barra, patio de lavandería y dos dormitorios (uno con baño). El segundo piso incluye tres dormitorios, sala de estar y área de estudio. La azotea ofrece un espacio versátil. Se entrega con especificaciones técnicas completas para una ejecución precisa.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 7,
        "id": 57
    },
    {
        "identity": "pl-0067",
        "name": "Residencia Unifamiliar con Doble Terraza, Carport y Áreas de Estudio Integradas",
        "category": "Casa",
        "area": 127,
        "rooms": 4,
        "floors": 3,
        "front": 7,
        "depth": 17,
        "dimencion": "7.5x17",
        "price": 30,
        "type": "diseno",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778036301/frpjykhxrxkwnoieovkv.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778036322/itbkraquh7ayuns4g9ox.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778036342/aqinvdjcgfskphsloq4q.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778036371/qyuypeoymx4sweyjm053.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias que valoran los espacios exteriores, Profesionales con oficina en casa",
        "description": "Vivienda de dos niveles que equilibra vida social y trabajo en casa. El primer piso incluye ingreso con jardín, carport, sala-comedor conectada a terraza, cocina con lavandería, un dormitorio, baño y estudio independiente. El segundo piso alberga tres dormitorios, sala de estar con balcón y una sala de cómputo, brindando confort y funcionalidad.",
        "masVendidos": false,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 6,
        "id": 58
    },
    {
        "identity": "pl-0068",
        "name": "Vivienda Unifamiliar Compacta con Librería y Distribución Funcional de Dos Niveles",
        "category": "Casa",
        "area": 60,
        "rooms": 3,
        "floors": 2,
        "front": 7.5,
        "depth": 8,
        "dimencion": "7x8",
        "price": 40,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Sanitarias",
            "Inst. Eléctricas"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778036602/xk78lvhlbrmuxulrxax8.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778036619/wtxncdiukc99rgatfokj.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778036636/qh5wl8uddue8s2fponzd.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778036658/z1vo1iptq8uzizbhhwxe.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Proyectos en terrenos pequeños o medianos",
        "description": "Vivienda moderna y eficiente para lotes pequeños. El primer nivel integra sala, comedor, cocina, librería y baño bajo la escalera. El segundo nivel alberga tres dormitorios y un baño común. Incluye elevaciones contemporáneas con techos a un agua, ofreciendo confort y privacidad en un diseño compacto.",
        "masVendidos": false,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 5,
        "id": 59
    },
    {
        "identity": "pl-0069",
        "name": "Residencia Contemporánea de Lote Profundo con Garaje Amplio y Estar Íntimo",
        "category": "Casa",
        "area": 150,
        "rooms": 5,
        "floors": 3,
        "front": 6,
        "depth": 25,
        "dimencion": "6x25",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778036895/hwsencddtz9nrifksrvo.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778036908/idygp2ouxzcwk94wbkrv.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778036919/gwqomoq4th0balabnhfr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778036934/ntkjm6h8f8z1dzxdkoev.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias que buscan áreas recreativas internas, ",
        "description": "Vivienda para terreno alargado con diseño fluido y amplio. El primer piso incluye garaje, zona social abierta, cocina conectada por pasadizo curvo y dos dormitorios. El segundo piso ofrece sala de TV y dormitorios adicionales con buena privacidad. Destaca por iluminación natural y ventilación cruzada eficiente.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 6,
        "id": 60
    },
    {
        "identity": "pl-0070",
        "name": "Edificación Mixta de 3 Niveles con Comercio en Planta Baja y Vivienda Multifamiliar",
        "category": "Departamento",
        "area": 120,
        "rooms": 4,
        "floors": 3,
        "front": 6,
        "depth": 20,
        "dimencion": "6x20",
        "price": 35,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037174/bjko7lfl5og5su2onfaq.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037197/vp1aiyturxqrfnfej9yk.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037221/qpwjttfsec2jzvul29gp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037283/za1ccoqlm2qp1egbbvxt.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Emprendedores e Inversionistas",
        "description": "Proyecto de uso mixto que optimiza la rentabilidad del suelo. El primer piso es un local comercial de planta libre con depósito y servicios. Los pisos superiores albergan la vivienda: zona social y dormitorios en el segundo nivel, más áreas de descanso y estar en el tercero. Incluye azotea y especificaciones técnicas para una construcción precisa.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 0,
        "id": 61
    },
    {
        "identity": "pl-0071",
        "name": "Residencia  Doble Nivel con Estacionamiento y Área Social Integrada",
        "category": "Casa",
        "area": 114,
        "rooms": 3,
        "floors": 2,
        "front": 6,
        "depth": 19,
        "dimencion": "6x19",
        "price": 35,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037567/opjwev8vsxzma9a9p51m.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037587/nratk2y3ppkgautqm3ox.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037612/eadpgpwwohfuwutvw4gm.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037865/crdbaibrcafd8jqf1tkg.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias que poseen dos vehículos, Terrenos angostos y profundos",
        "description": "Vivienda en lote de 6×19 m con zonificación eficiente. La planta baja integra sala, comedor, cocina con barra, dormitorio de servicio y garaje para dos autos. La planta alta alberga tres dormitorios con baños centrales. Incluye techo a dos aguas con pendientes que optimizan el drenaje pluvial.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 7,
        "id": 62
    },
    {
        "identity": "pl-0072",
        "name": "Residencial Multifamiliar de 4 Niveles con Salas Múltiples y Terraza Social",
        "category": "Casa",
        "area": 90,
        "rooms": 11,
        "floors": 1,
        "front": 6,
        "depth": 15,
        "dimencion": "6x15",
        "price": 45,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 60,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778120854/nub6nohvh3n147qqkfv0.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778120879/eaqfhdal6wgx8tnpjmtr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778120906/fqgkoguavqcg5ezevbbn.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778120990/p9ku2f6qxhphc7ntns6s.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias extensas o multifamiliares",
        "description": "Este proyecto arquitectónico propone una vivienda de tres niveles y azotea funcional. El 1er piso incluye sala, comedor, cocina independiente y tres dormitorios. El 2do y 3er piso cuentan con hasta cuatro dormitorios y amplias salas múltiples. La azotea dispone de lavandería, tendal y una terraza panorámica para actividades sociales.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 7,
        "id": 63
    },
    {
        "identity": "pl-0073",
        "name": "Residencia Unifamiliar con Cuarto de Servicio, Balcón y Azotea Integral",
        "category": "Casa",
        "area": 78,
        "rooms": 5,
        "floors": 2,
        "front": 6,
        "depth": 13,
        "dimencion": "6x13",
        "price": 35,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121257/fxedtega5nocdyjmfz3z.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121270/jeh1wyo6hgdidf0e6hjz.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121316/hlmdahyb3yozwlawhruw.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121327/zmjeh1o6ew0vl3orbl8d.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Construcción en lotes típicos de 6m de frente",
        "description": "Este proyecto arquitectónico plantea una vivienda de dos niveles más azotea para un lote de 6.00 m de frente. El 1er nivel integra áreas sociales y zona de servicio con dormitorio y baño independiente. El 2do nivel alberga dormitorios amplios y un balcón frontal. La azotea ofrece un espacio versátil para servicios y recreación, ideal para la vida urbana moderna.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 6,
        "id": 64
    },
    {
        "identity": "pl-0074",
        "name": "Residencia Unifamiliar de Tres Niveles con Estar Íntimo, Suite de Servicio y Terraza",
        "category": "Casa",
        "area": 90,
        "rooms": 7,
        "floors": 3,
        "front": 5,
        "depth": 16,
        "dimencion": "5x16",
        "price": 35,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121604/m19yy63jrxgp9z3mhq3m.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121629/dsyanyzc6ecysor3yt0h.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121639/wnrnztrprlwomphrnid7.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121650/kifkkh8luz8nbwvyrmzt.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Proyectos de inversión para alquiler",
        "description": "Este proyecto arquitectónico desarrolla una vivienda de cuatro niveles en un lote profundo. El 1° piso integra sala, comedor, cocina y un dormitorio con vista al patio. El 2° y 3° piso albergan dormitorios, estar familiar y halls de distribución. La azotea incluye dormitorio de servicio, área de tendal y una amplia terraza frontal para actividades al aire libre.",
        "masVendidos": false,
        "level": 3,
        "style": "",
        "cantidLaminas": 6,
        "id": 65
    },
    {
        "identity": "pl-0075",
        "name": "Edificio Multifamiliar Huampaní: Residencia de 5 Niveles con Terraza Social",
        "category": "Departamento",
        "area": 120,
        "rooms": 11,
        "floors": 4,
        "front": 6,
        "depth": 20,
        "dimencion": "6x20",
        "price": 50,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 60,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121994/wfunac97itxkuc8x3ajr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122053/fyhhdzvsmjym7lrumats.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122168/uy4ucqve3qqycl2lmfr0.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Desarrolladores Inmobiliarios",
        "description": "Este proyecto arquitectónico desarrolla una edificación multifamiliar de cinco niveles más azotea. El primer piso integra sala, comedor, cocina, tres dormitorios, patio central y hall de ingreso. Del 2do al 5to piso se mantiene una distribución funcional con lavandería y varios servicios higiénicos. La azotea ofrece una amplia terraza, zona de parrilla y áreas de estar al aire libre para el esparcimiento de los residentes.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 11,
        "id": 66
    },
    {
        "identity": "pl-0076",
        "name": "Edificación Comercial - Salones",
        "category": "Comercial",
        "area": 120,
        "rooms": 0,
        "floors": 3,
        "front": 6,
        "depth": 20,
        "dimencion": "6x20",
        "price": 34,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122463/ufkwlsameqr6xmkb2any.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122473/govhwpje9cqpkujgsozu.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122483/zyjnkkqfn0wxaafteuw2.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122494/uvwf0mly5i1gm5vpdjii.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Para Salones Comerciales",
        "description": "Este proyecto arquitectónico propone un espacio comercial distribuido en cuatro niveles técnicos. El sótano incorpora cisterna y sistemas de extracción para servicios y almacenamiento. El 1° piso cuenta con recepción, sala de espera, área de exhibición y servicios higiénicos. El mezzanine ofrece una planta libre con balcón hacia la zona de exhibición, ideal para administración o ampliación comercial.",
        "masVendidos": false,
        "level": 2,
        "style": "Moderno",
        "cantidLaminas": 6,
        "id": 67
    },
    {
        "identity": "pl-0077",
        "name": "Establecimiento Gastronómico Integral con Área de Mesas, Barra y Servicios Logísticos",
        "category": "Comercial",
        "area": 510,
        "rooms": 0,
        "floors": 2,
        "front": 17,
        "depth": 30,
        "dimencion": "17x30",
        "price": 35,
        "type": "diseno",
        "packageType": "Basico",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122795/su9ipnizmasxhbvz2l5d.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122807/habmojjyc35bs8ctrk1b.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122814/gzq9zvuextsmtwrwl91o.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Emprendedores del sector Restauración",
        "description": "Este proyecto arquitectónico desarrolla un establecimiento gastronómico con una distribución funcional y eficiente. La primera planta integra un área de mesas con barra de atención, una zona de producción con cocina, despensa, frigorífico y oficio, además de un sector logístico con depósito, control y estacionamiento para tres vehículos. El diseño se complementa con recepción, sala de espera y servicios higiénicos diferenciados.",
        "masVendidos": false,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 4,
        "id": 68
    },
    {
        "identity": "pl-0078",
        "name": "Edificación Multifamiliar Moderna de 4 Niveles con Balcones y Lavandería Integrada",
        "category": "Departamento",
        "area": 125,
        "rooms": 9,
        "floors": 4,
        "front": 5,
        "depth": 25,
        "dimencion": "5x25",
        "price": 120,
        "type": "plano",
        "packageType": "Completo",
        "originalPrice": 150,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778124424/qjn6e5sa7fpoglh6txkz.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778124432/knnppcmbsrubaj5qroeo.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778124446/irheioupqsfgzlbcz8ry.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778124454/kle4vgo3pksdsae8vnhe.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778124465/xcyctlzax7vfklxw2028.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Premium",
        "bonus": "",
        "idealFor": "Desarrolladores Inmobiliarios de Vivienda Social o Media",
        "description": "Este proyecto arquitectónico desarrolla una vivienda colectiva de cuatro niveles con distribución eficiente y funcional. El 1er y 2do piso incluyen tres dormitorios, áreas sociales integradas y muros de drywall para mayor versatilidad. Desde el 3er piso se incorporan amplios balcones que mejoran iluminación y ventilación. La azotea cuenta con lavandería y tendal, complementando una adecuada separación entre áreas privadas y sociales.",
        "masVendidos": false,
        "level": 5,
        "style": "Moderno",
        "cantidLaminas": 11,
        "id": 69
    },
    {
        "identity": "pl-0079",
        "name": "Residencia Multifuncional con Amplio Garage de Triple Altura",
        "category": "Departamento",
        "area": 140,
        "rooms": 5,
        "floors": 4,
        "front": 7,
        "depth": 20,
        "dimencion": "7x20",
        "price": 43,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 60,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778125069/kk9mrxp0exku2fxc0eut.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778125083/b8oydhudvtsbms5we65n.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778125094/zctaq7b5i2o3r5dkvwsq.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778125105/llocne0clwmkwqmyamzb.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias numerosas que buscan privacidad",
        "description": "Este proyecto arquitectónico combina un amplio espacio logístico en el primer nivel con una vivienda completa en los pisos superiores. El primer piso incorpora un garage de gran capacidad, patios de ventilación y depósito. El segundo piso integra sala, comedor, cocina, estudio y dormitorios con baño. El tercer piso alberga dormitorios adicionales y salas de estar, conectados mediante un núcleo central de escaleras y pasillos funcionales.",
        "masVendidos": false,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 11,
        "id": 70
    },
    {
        "identity": "pl-0080",
        "name": "Edificación de Uso Mixto con Garage de Gran Capacidad, Recepción y Habitaciones Múltiples",
        "category": "Hotel",
        "area": 200,
        "rooms": 16,
        "floors": 3,
        "front": 10,
        "depth": 20,
        "dimencion": "10x20",
        "price": 60,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 80,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "DWG",
            "PDF"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778125450/rinipkc5k2vbgw1ltkjm.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778125461/jthetyoe9glt5t4kj3xc.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778125467/ea2rjjcyswhlyrurjazf.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778125484/rwlxch0yncvj5jos0ooo.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Inversionistas en el sector de Hospedaje o Hotelería",
        "description": "Este diseño arquitectónico organiza un programa funcional en tres niveles. El primer nivel está destinado a logística y servicios, con garage, almacén, lavandería y habitaciones de apoyo. El segundo y tercer nivel distribuyen habitaciones independientes mediante pasadizos y áreas de recepción con balcón frontal. El proyecto incluye un cuadro de vanos con especificaciones técnicas para puertas y ventanas, garantizando precisión constructiva.",
        "masVendidos": true,
        "level": 4,
        "style": "Moderno",
        "cantidLaminas": 9,
        "id": 71
    },
    {
        "identity": "pl-0081",
        "name": "Edificio de Hospedaje Turístico con Garage, Snack-Bar y Habitaciones de Categoría Mixta",
        "category": "Hotel",
        "area": 270,
        "rooms": 18,
        "floors": 4,
        "front": 15,
        "depth": 19,
        "dimencion": "15x19",
        "price": 60,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 70,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778125869/y7ta38pbkz9bod2ycglm.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778125878/fdbwycf15puu0ghtqsjj.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778125885/m4hk6pnuzinacrnw1hui.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778125891/narg3qfgu9movox3tseh.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Inversionistas del Sector Hotelero",
        "description": "Este proyecto arquitectónico presenta una solución integral para el sector hospitalidad, distribuida en cuatro niveles optimizados para la gestión de huéspedes. El 1° Piso funciona como el núcleo operativo, albergando una Recepción estratégica, administración con vigilancia, un área de Snack, depósitos y cuatro amplios garajes. A partir del 2°, 3° y 4° Piso, la edificación se dedica exclusivamente al alojamiento, ofreciendo una variedad de configuraciones que incluyen Habitaciones Matrimoniales, Dobles y Simples. Cada nivel de habitaciones cuenta con un área de Oficio para la gestión de limpieza y pasadizos de circulación fluida que conectan con un hall central, garantizando una operación eficiente y confort para el usuario.",
        "masVendidos": false,
        "level": 4,
        "style": "Moderno",
        "cantidLaminas": 14,
        "id": 72
    },

    {
        "identity": "pl-0082",
        "name": "Edificio Residencial Multifamiliar de 7 Niveles.",
        "category": "Departamento",
        "area": 532,
        "rooms": 12,
        "floors": 6,
        "front": 14,
        "depth": 38,
        "dimencion": "14x38",
        "price": 40,
        "type": "diseno",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778702908/rnvv9euc2tcwg0a7z7gh.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778702924/kmysrq3v2ixkihwivhua.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778702930/pe710sk9bzrwvrvzkame.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778702939/upgmm9tfropih0nmpujm.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Proyectos de vivienda multifamiliar, Familias numerosas",
        "description": "Diseño arquitectónico optimizado para alta densidad urbana. Presenta una distribución eficiente de departamentos independientes en 7 plantas, maximizando el uso de áreas comunes y circulaciones verticales mediante ascensores y escaleras de emergencia.",
        "masVendidos": false,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 8,
        "id": 73
    },
    {
        "identity": "pl-0083",
        "name": "Complejo Multifamiliar con Zócalo Comercial - Diseño en \"U\".",
        "category": "Departamento",
        "area": 1400,
        "rooms": 20,
        "floors": 6,
        "front": 37,
        "depth": 38,
        "dimencion": "37x38",
        "price": 40,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778703210/hxmlk8bwkbfe0tgiixzh.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778703220/kcs7wgnyatumof65dzzw.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778703227/kd5ylrtj4tscqft1yyim.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778703235/fvf7fmp8o0a9jqcdtake.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Desarrolladores inmobiliarios, Familias que desean vivir del alquiler",
        "description": "Proyecto arquitectónico integral que optimiza un terreno de esquina mediante una distribución en \"U\" para garantizar iluminación y ventilación natural. La primera planta está destinada a locales comerciales con estacionamiento frontal , mientras que los niveles superiores ofrecen departamentos modernos con distribuciones independientes.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 18,
        "id": 74
    },
    {
        "identity": "pl-0084",
        "name": "Proyecto de Alojamiento / Hostal",
        "category": "Hotel",
        "area": 414,
        "rooms": 26,
        "floors": 3,
        "front": 23,
        "depth": 18,
        "dimencion": "28x18",
        "price": 40,
        "type": "diseno",
        "packageType": "Intermedio",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778703484/aan0n3x0zwir6lcceyxa.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778703495/hgf6teyq2dluf1mbj44g.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778703502/igkvxzkfz0cm6hvlzaxw.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Propietarios de Terrenos en Zonas Comerciales, ",
        "description": "Diseño especializado para hospedaje que maximiza el número de unidades habitacionales con baño privado. El proyecto incluye una zona de recepción, administración, estacionamiento interno y áreas de servicio completas en la azotea (lavandería y planchado) para una operación eficiente.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 5,
        "id": 75
    },
    {
        "identity": "pl-0085",
        "name": "Casa-Negocio Moderna, Multifamiliar",
        "category": "Departamento",
        "area": 90,
        "rooms": 6,
        "floors": 4,
        "front": 6,
        "depth": 15,
        "dimencion": "6x15",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778704499/esphpc5k3i60j5kqzagj.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778704509/txefbdct1bwql5pkwcda.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778704516/hxbtunwvnxsnl6dpmc0c.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Parejas o familias pequeñas",
        "description": "Diseño arquitectónico inteligente que optimiza el uso de suelo en lotes estrechos, integrando un amplio local comercial independiente con baño en el primer nivel y una vivienda completa en el segundo nivel que prioriza el confort y la privacidad.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 4,
        "id": 76
    },
    {
        "identity": "pl-0086",
        "name": "Vivienda con Local Comercial",
        "category": "Comercial",
        "area": 240,
        "rooms": 14,
        "floors": 3,
        "front": 8,
        "depth": 30,
        "dimencion": "8x30",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778704790/xlnsiy9wuukam7rb8sag.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778704804/zaypzzazvxrggssdshsp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778704813/ascmgrsapmanaeel3n8v.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias pequeñas o parejas",
        "description": "Diseño arquitectónico optimizado para terrenos de fachada reducida que integra perfectamente el uso comercial y residencial. El primer nivel ofrece un amplio local comercial independiente, mientras que el segundo piso alberga una vivienda confortable con áreas sociales integradas y un dormitorio privado con tina.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 4,
        "id": 77
    },
    {
        "identity": "pl-0087",
        "name": "Edificio Residencial Multifamiliar, comercial",
        "category": "Casa",
        "area": 77,
        "rooms": 6,
        "floors": 4,
        "front": 11,
        "depth": 7,
        "dimencion": "11x7",
        "price": 30,
        "type": "diseno",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Cortes y Secciones",
            "Arquitectura"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778705071/gpcmlrjmytktyw1aineg.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778705086/q6cymeiemxk56qk27mta.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778705092/mrjaalowvnlwoaqs0a1c.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778705101/vbrixvuzhz3brxoiwxiu.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Inversionistas inmobiliarios",
        "description": "Diseño arquitectónico integral que ofrece departamentos independientes con distribuciones optimizadas. Incluye una azotea diseñada para el esparcimiento con zona de parrilla y terraza, ideal para proyectos de densificación urbana.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 6,
        "id": 78
    },
    {
        "identity": "pl-0088",
        "name": "Edificio Residencial Multifamiliar en Lote Irregular",
        "category": "Departamento",
        "area": 120,
        "rooms": 4,
        "floors": 4,
        "front": 13,
        "depth": 9,
        "dimencion": "13x9",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778705430/idbciui8irwezxcwkev3.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778705442/hznaqcopxwawuaxaihds.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778705455/vhj1wljyvgtqzqwjxrmg.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Propietarios de terrenos irregulares",
        "description": "Proyecto arquitectónico diseñado para maximizar el aprovechamiento de lotes con geometría irregular. Ofrece departamentos funcionales de dos dormitorios con áreas sociales integradas (sala-comedor), cocina independiente y excelente ventilación mediante pozos de luz estratégicos.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 5,
        "id": 79
    },
    {
        "identity": "pl-0089",
        "name": "Edificio Residencial Multifamiliar Compacto",
        "category": "Departamento",
        "area": 336,
        "rooms": 15,
        "floors": 5,
        "front": 14,
        "depth": 24,
        "dimencion": "14x24",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778705740/faelgxum5doq9borsuo3.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778705749/wegcjfj73fafni1yibjg.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778705756/ekjmabdienf5sduhhrxe.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778705765/lvciky9sfcormxdkh0xe.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Propietarios de terrenos entre vecinos",
        "description": "Diseño arquitectónico de departamentos independientes distribuidos en dos niveles, optimizado para terrenos con tres frentes colindantes. La distribución prioriza la iluminación mediante patios internos y una fachada principal con vista a la vía pública.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 14,
        "id": 80
    },
    {
        "identity": "pl-0090",
        "name": "Condominio Vertical con Estacionamiento Automatizado",
        "category": "Casa",
        "area": 0,
        "rooms": 12,
        "floors": 3,
        "front": 20,
        "depth": 11,
        "dimencion": "20x11",
        "price": 30,
        "type": "diseno",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706187/p9urunlvp5myu1dts8pa.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706197/bzmoodjchqu7h5jgxmys.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706202/jvglohnyovjw8gqyrdzr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Desarrolladores inmobiliarios",
        "description": " Proyecto residencial de alta eficiencia que maximiza el espacio mediante un sistema de estacionamiento automatizado (eleva-autos) en semisótano. El edificio cuenta con múltiples niveles de departamentos independientes, elevador, escalera central y un área de roof garden para el disfrute de los residentes.   ",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 4,
        "id": 81
    },
    {
        "identity": "pl-0091",
        "name": "Vivienda con Salón de Belleza Integral",
        "category": "Casa",
        "area": 0,
        "rooms": 4,
        "floors": 2,
        "front": 5,
        "depth": 10,
        "dimencion": "5x10",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706434/iaz7mq1bbw1kr4a4fwjs.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706443/xzucxbcmqjlhj6gtuvft.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706447/arrieeklek1o9gmqrygp.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias pequeñas",
        "description": "Diseño funcional de dos niveles más azotea que integra un centro de estética profesional en la planta baja y una vivienda moderna e independiente en el segundo nivel. El proyecto destaca por una zonificación clara que permite operar un negocio de servicios sin sacrificar la privacidad del hogar.",
        "masVendidos": false,
        "level": 3,
        "style": "Clásico",
        "cantidLaminas": 5,
        "id": 82
    },
    {
        "identity": "pl-0092",
        "name": "Residencia Unifamiliar Estilo Galería",
        "category": "Casa",
        "area": 210,
        "rooms": 6,
        "floors": 1,
        "front": 5,
        "depth": 22,
        "dimencion": "5x22",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706673/nfl8g2lcveagflgjtbh7.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706683/ykzhfq4m4ia5xd3cfsaf.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706690/oqpjgagdesxcdrxkdnc3.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706698/g1gtkl6scpxz4kvpiqtx.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Propietarios de lotes urbanos estrechos",
        "description": "Diseño arquitectónico moderno que optimiza terrenos profundos y estrechos. La planta baja integra un garaje frontal y áreas sociales fluidas que conectan con un patio posterior, mientras que el segundo nivel ofrece tres dormitorios espaciosos y una sala familiar privada.",
        "masVendidos": false,
        "level": 3,
        "style": "Clásico",
        "cantidLaminas": 9,
        "id": 83
    },
    {
        "identity": "pl-0093",
        "name": "Proyecto Residencial Eficiente para Lotes de 60 $m^2$. ",
        "category": "Casa",
        "area": 60,
        "rooms": 4,
        "floors": 3,
        "front": 6,
        "depth": 10,
        "dimencion": "6x10",
        "price": 30,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones",
            "Inst. Gas"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706943/hk1pkcpel0mhw5pbu8cr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706963/mllmjxjn3ceq6mvjaj0m.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706978/arl0u424mrphchw5sluw.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706986/xgq4xoc4zncriqt0mqxq.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias en crecimiento",
        "description": "Diseño arquitectónico inteligente optimizado para terrenos compactos de 6x10 metros. El proyecto ofrece una distribución de departamentos con tres dormitorios, maximizando el área privada y asegurando una circulación fluida a través de un hall central y una escalera de tres tramos.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 9,
        "id": 84
    },
    {
        "identity": "pl-0094",
        "name": "Vivienda Unifamiliar Moderna ",
        "category": "Casa",
        "area": 90,
        "rooms": 5,
        "floors": 1,
        "front": 6,
        "depth": 15,
        "dimencion": "6x15",
        "price": 20,
        "type": "diseno",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778707302/qladqwx75gzh2xx1bswg.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778707314/unlcwu1hzisqiogh6xlx.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778707323/pxdusroxskoygehamc2v.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias consolidadas",
        "description": "Diseño arquitectónico de tres niveles que destaca por su zonificación eficiente. El primer piso integra áreas sociales y garaje; el segundo nivel está dedicado exclusivamente al área privada con dormitorios, y el tercer nivel ofrece un espacio versátil con una amplia terraza para el esparcimiento.  ",
        "masVendidos": false,
        "level": 2,
        "style": "Moderno",
        "cantidLaminas": 2,
        "id": 85
    },
    {
        "identity": "pl-0095",
        "name": "Vivienda Unifamiliar con Espacios de Home Office",
        "category": "Casa",
        "area": 127,
        "rooms": 5,
        "floors": 3,
        "front": 7,
        "depth": 17,
        "dimencion": "7x17",
        "price": 20,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778707555/bedhe1jirkuzsqvovc5k.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778707564/il3yycdc3s2vmqgvxtpk.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Usuarios que buscan confort y ventilación",
        "description": "Diseño arquitectónico de dos niveles funcionalmente zonificados para el equilibrio entre la vida familiar y el trabajo. El primer nivel integra áreas sociales fluidas con un estudio independiente, mientras que el segundo piso prioriza el descanso y la productividad con dormitorios amplios y una sala de cómputo dedicada.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 3,
        "id": 86
    },

    //nuevos datos 24052026 inicio pl-0087 a pl-0096
    {
        "identity": "pl-0096",
        "name": "Vivienda Familia, Diseño Contemporáneo con Piscina Privada",
        "category": "Casa",
        "area": 200,
        "rooms": 4,
        "floors": 3,
        "front": 10,
        "depth": 20,
        "dimencion": "10x20",
        "price": 80,
        "type": "plano",
        "packageType": "Completo",
        "originalPrice": 100,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779660774/cqox1gjgjo6j1wo8tyka.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779660810/vodvxc6mwicocnaluxr6.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779660817/tii6jgwxjwmueymd3gpi.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779660825/hdrycsygnpn8arwyc2zc.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Premium",
        "bonus": "",
        "idealFor": "Familias consolidadas, inversionistas interesados en propiedades de diseño exclusivo para vivienda de lujo, o parejas.",
        "description": "Diseño arquitectónico de dos niveles para un terreno de 200 m², enfocado en la integración de espacios sociales y privados. Cuenta con áreas de recreación, piscina y terrazas en el primer nivel, conectadas a un área social abierta. El segundo nivel prioriza la privacidad con dormitorios amplios, terraza privada y áreas de estudio, optimizando la iluminación natural a través de vacíos internos y ventanales amplios.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 19,
        "id": 87
    },
    {
        "identity": "pl-0097",
        "name": "Proyecto Mixto Comercial-Residencial",
        "category": "Hotel",
        "area": 100,
        "rooms": 8,
        "floors": 3,
        "front": 10,
        "depth": 10,
        "dimencion": "10x10",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 70,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779661165/mobya8dsdhkypfgan3eb.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779661173/xe82blllqzvjkm9dhu4q.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779661181/ejmhhrga3tc78zioonp5.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779661191/qyfhjgmfbmnkqd9jneu7.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Empresarios o comerciantes, familias emprendedoras",
        "description": "Diseño funcional de tres niveles optimizado para maximizar el uso del terreno. El primer nivel está dedicado a un amplio local comercial, mientras que los niveles superiores albergan una zona residencial con cuatro habitaciones, balcones frontales y áreas de servicio (lavandería y tendal) independientes, permitiendo una convivencia eficiente entre el uso comercial y habitacional.",
        "masVendidos": false,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 8,
        "id": 88
    },
    {
        "identity": "pl-0098",
        "name": "Complejo Corporativo-Residencial: Integración de Oficinas y Departamentos",
        "category": "Casa",
        "area": 600,
        "rooms": 42,
        "floors": 6,
        "front": 17,
        "depth": 42,
        "dimencion": "14x43",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779661471/o0138927ntu4g3rg2dbf.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779661483/cel2ykyae4bkhwoh6yvg.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779661492/obl2zn2doox7c8h9hwpn.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Inversionistas inmobiliarios",
        "description": "Diseño arquitectónico versátil de múltiples niveles que combina un sector corporativo de siete oficinas independientes con un sector residencial compuesto por unidades habitacionales de distintos formatos. La distribución optimiza el uso del espacio con áreas comunes, balcones estratégicos y una zonificación clara entre el entorno de trabajo y el descanso, ideal para proyectos de mediana y gran escala en zonas urbanas de alta actividad.",
        "masVendidos": false,
        "level": 2,
        "style": "Moderno",
        "cantidLaminas": 96,
        "id": 89
    },
    {
        "identity": "pl-0099",
        "name": "Multifamiliar : Vivienda Residencial de Dos Niveles",
        "category": "Departamento",
        "area": 120,
        "rooms": 9,
        "floors": 3,
        "front": 6,
        "depth": 20,
        "dimencion": "6x20",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "DWG",
            "PDF"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779661765/wxaoknv8wnw7szbbash0.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779661778/plk7w17wh2lwbo5wh4xe.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779661784/uxg3uvr690hv1ugsdyqw.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias jóvenes, desarrolladores que buscan un modelo optimizado",
        "description": "Proyecto residencial estructurado en dos niveles y área de azotea, diseñado para maximizar la habitabilidad en terrenos estrechos. El primer piso integra áreas de estudio, sala-comedor y cocina, mientras que el segundo nivel prioriza la zona privada con dormitorios y servicios higiénicos. Incluye una distribución eficiente de áreas comunes y una azotea versátil para uso recreativo.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 5,
        "id": 90
    },
    {
        "identity": "pl-0100",
        "name": "Edificio Multifamiliar de Alta Capacidad",
        "category": "Departamento",
        "area": 260,
        "rooms": 12,
        "floors": 4,
        "front": 10,
        "depth": 26,
        "dimencion": "10x26",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779662099/y7b4zcy8insscer2rnum.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779662110/bdzfkbrmdgut9dgbkwh8.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779662117/otbu3jcduzw97bl4zhsz.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Inversionistas inmobiliarios",
        "description": "Proyecto arquitectónico integral compuesto por un nivel de semisótano destinado a estacionamiento vehicular y servicios, seguido de dos niveles habitacionales con múltiples unidades. La distribución incluye áreas sociales, cocina, dormitorios con baños privados y áreas de servicio independientes, optimizando el uso del terreno para maximizar la capacidad de vivienda sin comprometer el confort.",
        "masVendidos": false,
        "level": 2,
        "style": "Moderno",
        "cantidLaminas": 5,
        "id": 91
    },
    {
        "identity": "pl-0101",
        "name": " \"Multifamiliar\": Diseño de Vivienda Vertical de Cuatro Niveles",
        "category": "Departamento",
        "area": 90,
        "rooms": 6,
        "floors": 3,
        "front": 6,
        "depth": 15,
        "dimencion": "6x15",
        "price": 10,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 30,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779662342/nwrhy7biantzmlvcwwtx.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias numerosas",
        "description": "Proyecto residencial de cuatro niveles con una distribución optimizada para maximizar el área útil. El primer nivel cuenta con garaje, sala-comedor y cocina, mientras que los niveles superiores integran dormitorios con baños privados y zonas de estudio, utilizando ductos para ventilación y manteniendo una coherencia en el diseño de los acabados interiores.",
        "masVendidos": false,
        "level": 2,
        "style": "Moderno",
        "cantidLaminas": 1,
        "id": 92
    },
    {
        "identity": "pl-0102",
        "name": "Residencia Urbana \"Compacta\": Diseño Eficiente de Dos Niveles",
        "category": "Casa",
        "area": 35,
        "rooms": 3,
        "floors": 3,
        "front": 5,
        "depth": 7,
        "dimencion": "5x7",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 60,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones",
            "Estructuras"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779662562/amekgaxtrfvfztpxr5mv.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779662572/ksinojckxoh8ce3zwsqr.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779662578/qafozpj5newqp9uhocz0.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Personas solteras o parejas jóvenes",
        "description": "Diseño arquitectónico de dos niveles optimizado para terrenos de dimensiones reducidas. La distribución integra sala, kitchenette y un jardín en el primer nivel, conectando mediante una escalera a un área privada con dormitorio y baño en el segundo nivel, maximizando el aprovechamiento del espacio disponible.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 6,
        "id": 93
    },

    //nuevos datos iniciamos desde pl-0103
    {
        "identity": "pl-0103",
        "name": "Vivienda unifamiliar : Diseño Residencial de Dos Niveles con Cochera",
        "category": "Casa",
        "area": 75,
        "rooms": 6,
        "floors": 1,
        "front": 5,
        "depth": 15,
        "dimencion": "5x15",
        "price": 45,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 60,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779674747/jgktmou77yzjcxib74iq.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779674755/bmidnl4anarx9it2xits.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779674763/odpjpv6fxn46t6d1tafi.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779674770/iot2sasrrq3txafvlsjq.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias jóvenes, inversionistas, propietarios",
        "description": "Diseño arquitectónico eficiente de dos niveles, ideal para terrenos alargados. El primer nivel incluye una cochera independiente, sala, comedor y cocina funcional. El segundo nivel prioriza la zona íntima, albergando tres dormitorios y servicios higiénicos, con una distribución lineal que optimiza la circulación y el aprovechamiento de cada metro cuadrado.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 6,
        "id": 94
    },
    {
        "identity": "pl-0104",
        "name": "Vivienda unifamiliar: Diseño Integrado de Dos Niveles",
        "category": "Casa",
        "area": 144,
        "rooms": 6,
        "floors": 3,
        "front": 8,
        "depth": 18,
        "dimencion": "8x18",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675091/nopxacn29o0yyqophqoq.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675098/g26pzxwgsokpqbkjyoed.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675105/flazhi1l7gpmujzh9a2r.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias que valoran las áreas verdes",
        "description": "Proyecto residencial que prioriza la integración de espacios sociales y naturales. El primer nivel destaca por sus amplias áreas de jardín, sala, comedor y un estudio, además de estacionamiento propio. El segundo nivel se organiza en torno a un hall de distribución, albergando dormitorios, salas de estar y baños, manteniendo una ventilación eficiente mediante áreas de vacío.",
        "masVendidos": false,
        "level": 2,
        "style": "Minimalista",
        "cantidLaminas": 4,
        "id": 95
    },
    {
        "identity": "pl-0105",
        "name": "Vivienda unifamiliar: Diseño Residencial de Dos Niveles con Terrazas",
        "category": "Casa",
        "area": 160,
        "rooms": 0,
        "floors": 3,
        "front": 9,
        "depth": 18,
        "dimencion": "9x18",
        "price": 55,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 70,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "DWG",
            "PDF"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675312/btiywrbxv4khvzbgvzeh.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675321/dztgudwodv2w7meehqlp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675327/qfjsmud6z1sa3s97wik8.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675336/t8ync22sxa6w8hkmmyxw.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias, profesionales",
        "description": "Diseño arquitectónico de dos niveles que optimiza la integración de espacios sociales y privados. El primer nivel cuenta con cochera, estudio, sala-comedor, cocina y una terraza posterior. El segundo nivel se enfoca en la zona privada con tres dormitorios, una sala de estar, servicios higiénicos y una terraza delantera adicional, ofreciendo versatilidad y confort.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 15,
        "id": 96
    },
    {
        "identity": "pl-0106",
        "name": "Vivienda Unifamiliar: Diseño de Lujo con Piscina y Jardín",
        "category": "Casa",
        "area": 240,
        "rooms": 6,
        "floors": 3,
        "front": 16,
        "depth": 15,
        "dimencion": "16x15",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 60,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675560/ad2eqwdlamqvfc4p1pxo.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675571/uscdt5wyvyyzqekp4cht.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675582/fgzqn8tekf6psfuxr4ap.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675593/qlwctrqp8xwlhzlogusa.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias, inversionistas",
        "description": "Diseño arquitectónico unifamiliar de dos niveles que integra áreas sociales y recreativas privadas. El primer nivel incluye cochera, cocina, comedor, sala y un área exterior con piscina, parrilla y jardín. El segundo nivel cuenta con una distribución de dormitorios, sala de estar y un amplio jardín en la parte posterior, promoviendo espacios ventilados y luminosos.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 7,
        "id": 97
    },
    {
        "identity": "pl-0107",
        "name": "Vivienda unifamiliar: Proyecto Mixto \"Urbano Comercial\": Locales y Residencia Funcional",
        "category": "Casa",
        "area": 180,
        "rooms": 6,
        "floors": 3,
        "front": 10,
        "depth": 18,
        "dimencion": "10x18",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675828/ffd58wmkjdszwb3brayv.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675840/drrodgukkh4kelyeyjdi.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675850/qgodbaxccugdraou87ov.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779675866/b2qajvm5m1w6xxvkh1f7.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Empresarios o comerciantes",
        "description": "Diseño arquitectónico de dos niveles diseñado para maximizar la rentabilidad del terreno. El primer nivel se dedica a espacios comerciales (dos tiendas) y un depósito, junto con una cochera privada. El segundo nivel alberga una unidad residencial completa que incluye tres dormitorios, áreas de servicio (lavandería), cocina, sala, comedor y una terraza exterior para mayor confort.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 6,
        "id": 98
    },
    {
        "identity": "pl-0108",
        "name": "Vivienda unifamiliar : Edificio de Tres Niveles con Oficina Independiente",
        "category": "Casa",
        "area": 162,
        "rooms": 12,
        "floors": 1,
        "front": 6,
        "depth": 27,
        "dimencion": "6x27",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 55,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779676171/nhndmfo6uxtxjc6yyecp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779676178/f4an9xwhjfwv0xybixra.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779676186/whbacdmpuwuj5fil0nit.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1779676198/ubtqh3tzyduafsyfma5h.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Empresarios, inversionistas",
        "description": "Diseño arquitectónico versátil de tres niveles. El primer nivel destaca por integrar una zona de recepción, oficina y cochera, con áreas sociales como cocina, comedor y bar. Los niveles superiores están optimizados para la zona residencial, incluyendo múltiples dormitorios, salas de estar y balcones, manteniendo una estructura de circulación eficiente mediante pasadizos y escaleras interiores.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 5,
        "id": 99
    }

];

export default plansData;